import 'lazysizes';
import './../../css/website/scss/bootstrap.scss';
import './../../css/website/scss/main.scss';
import 'slick-carousel/slick/slick';
import 'fancybox/dist/js/jquery.fancybox';
import 'picturefill/src/picturefill';
import 'jquery-ajax-unobtrusive/dist/jquery.unobtrusive-ajax';
import 'jquery-validation/dist/jquery.validate';
import 'jquery-validation-unobtrusive/dist/jquery.validate.unobtrusive';
import 'jcf/dist/js/jcf';
import 'jcf/dist/js/jcf.select';
import * as Merchello from './../../App_Plugins/Merchello/client/js/merchello.ui.js';
import './../../App_Plugins/UmbracoForms/Assets/Themes/Default/umbracoforms.js';
import './../../App_Plugins/UmbracoForms/Assets/moment/min/moment-with-locales.min.js';
import './../../App_Plugins/UmbracoForms/Assets/pikaday/pikaday.js';
import './../../App_Plugins/UmbracoForms/Assets/datepicker.init.js';

jQuery(function () {
    initFileInputs();
    initMobileNav();
    initDropDownClasses();
    initMenuLayout();
    initCustomForms();
    initSlickCarousel();
    initLoadMore();
    initRetinaCover();
    initAccordion();
    initFancybox();
   // initRecaptcha();
    initTabNav();
    initShowFilter();
    initIndentFix();
    initFormValidation();
    initPopups();
    initBlogReplyForm();
    initHelpForm();
    initAnchors();
    initRecaptchaChange();
    initStoryFormText();
    initStoryFormDragDrop();
    initShareLinks();
    initScrollTop();
    initTabs();
    initFormState();
    initEditForm();
    initAdditionalValidation();
    initProfUpgrade();

    Merchello.MUI.init();
    initAddProducts();
    initChangeOption();
    initChangeQuantity();
    initRemoveProduct();
    initApplyDiscount();
    initAddressLookup();
    initDonation();
    initGiftAid();
    initCartScroll();
    initDonate();

    if ($('#SagePayForm').length > 0) {
        $('body').hide();

        setTimeout(function () {
            $('#submit').click();
        }, 500);

        setTimeout(function () {
            $('body').show();
        }, 1000);
    }
});




/*
 * Donate functions
 */

function initDonate()
{
    // Check if modal has already been shown in this session
    if (!sessionStorage.getItem('donateModalShown'))
    {
        setTimeout(function () {
            $('#donateModal').addClass('active');
            sessionStorage.setItem('donateModalShown', 'true');
        }, 5000); // 5 Second timeout
    }

    // Show modal when clicking the donate button
    $('#donateButton').on('click', function () {
        $('#donateModal').addClass('active');
    });

    // Close modal when clicking the close button
    $('#closeDonate').on('click', function () {
        $('#donateModal').removeClass('active');
    });

    // Close modal when clicking outside of the modal content
    $(window).on('click', function (e) {
        const modal = $('#donateModal')[0];
        if (e.target === modal) {
            $('#donateModal').removeClass('active');
        }
    });
}


/*
 * Shop functions
 */

var cartTop = $('#headerBasketAdd').offset().top;

function initCartScroll() {
    $(window).resize(function () {
        cartScroll();
    });

    $(window).scroll(function () {
        cartScroll();
    });
}


function cartScroll() {
    var currentScroll = $(window).scrollTop();

    if (currentScroll >= cartTop) {
        $('#headerBasketAdd').css({
            position: 'fixed',
            top: '0',
            left: $('#headerBasket').offset().left
        });
    } else {
        $('#headerBasketAdd').css({
            position: 'absolute',
            top: 'auto',
            left: 'auto'
        });
    }
}

// add products from page to users basket
var addedItems = 0;
function initAddProducts() {
    $('a[data-nem="productitem"]').click(function (event) {
        event.preventDefault();
        var loggedIn = $(this).data('logged-in');
        var redirectUrl = $(this).data('redirect-url')
        if (loggedIn != undefined && redirectUrl != undefined) {
            if (!loggedIn) {
                window.location = redirectUrl;
                return;
            }
        }

        var available = $(this).data('available');
        if (available != undefined) {
            if (!available) {
                alert('This product is currently not available to purchase.');
                return;
            }
        }

        var hasRoles = $(this).data('has-roles');
        var roles = $(this).data('roles');
        if (hasRoles != undefined && roles != undefined) {
            if (!hasRoles) {
                if ($('.product-frame').length > 0) {
                    $('.product-frame .error-text').remove();
                    $('.product-frame').append('<span class="error-text"><span>You must have one of the following roles to purchase this product: ' + roles + '. Please go to your profile to register for these roles</span></span>');
                } else {
                    alert('You must have one of the following roles to purchase this product: ' + roles + '. Please go to your profile to register for these roles');
                }
                return;
            }
        }

        var postData = "";
        var optionData = "";
        var totalQty = 0;
        var product = this;
        var qty = 1;
        postData = "Quantity=" + qty;
        totalQty += qty;

        var key = $(product).data('product-key');
        if (key != undefined) {
            postData += "&ProductKey=" + key;
        }

        for (var i = 0; i < $('.product-option').length; i++) {
            var option = $(product).data('product-option-' + i);
            if (option != undefined) {
                postData += "&OptionChoices[" + i + "]=" + option;
                optionData += "&options[" + i + "]=" + option;
            }
        }

        var requiresOptions = $('.product-option').length > 0;
        if (requiresOptions) {
            for (var i = 0; i < $('.product-option').length; i++) {
                if (postData.indexOf("OptionChoices[" + i + "]") < 0) {
                    alert('You must select a choice for each of the options. Please do so and try again.');
                    return;
                }
            }
            
        }

        var url = $(product).data('success-redirect-url');
        if (url != undefined) {
            postData += "&SuccessRedirectUrl=" + url;
        }

        var token = $(product).find('input[name="__RequestVerificationToken"]');
        if (token != undefined) {
            postData += "&" + $(token).attr('name') + '=' + $(token).attr('value');
        }

        var productLink = $(this);
        var url = '/umbraco/surface/StoreBasket/CheckAddProduct?key=' + key;
        if (requiresOptions) {
            url = '/umbraco/surface/StoreBasket/CheckAddVariant?key=' + key + optionData;
        }
        $.ajax({
            type: 'GET',
            url: url,
            cache: false
        }).then(function (data) {
            if (data.Success) {
                Merchello.MUI.AddItem.postUrl = '/umbraco/Merchello/StoreBasket/AddBasketItem';

                if (postData != '') {
                    $.ajax({
                        type: 'POST',
                        url: Merchello.MUI.AddItem.postUrl,
                        data: postData
                    }).then(function (result) {
                        Merchello.MUI.Notify.info('Successfully added item to basket');

                        if ($(product).data('product-name') != undefined && $(product).data('product-price') != undefined) {
                            $('#productName').html($(product).data('product-name'));
                            $('#productPrice').html($(product).data('product-price'));
                        }

                        var url = '/umbraco/surface/StoreBasket/GetTotals';
                        $.ajax({
                            type: 'GET',
                            url: url,
                            cache: false,
                            success: function (data) {
                                var total = $('.shoping-card-block').find('[data-muivalue="total"]');
                                if (total.length > 0) {
                                    $(total).html(data.TotalPrice);
                                }

                                var label = $('[data-muilabel="basketcount"]');
                                if (label.length > 0) {
                                    $(label).html(data.ItemQuantityCount);
                                }

                                var itemText = $('[data-label="basket-item"]');
                                if (itemText.length > 0) {
                                    if (data.ItemQuantityCount > 1) {
                                        $(itemText).html("items");
                                    } else if (data.ItemQuantityCount > 0) {
                                        $(itemText).html("item");
                                    }
                                }

                                if (data.ItemQuantityCount > 0) {
                                    $('#headerBasket .hasItems').show();
                                    $('#headerBasket .noItems').hide();
                                }
                            },
                            error: function (err) {
                                Merchello.MUI.Logger.captureError(err);
                            }
                        });
                
                        cartScroll();

                        addedItems++;
                        setTimeout(function () {
                            if (addedItems == 1) {
                                $('body').removeClass('cart-active add');
                                addedItems = 0;
                            } else {
                                addedItems--;
                            }
                        }, 7000);
                    }, function (err) {
                        Merchello.MUI.Logger.captureError(err);
                    });
                }
                postData = "";

                if (data.ReachedMax) {
                    $('a[data-product-key="' + key + '"]').removeClass('can-add');
                    $('a[data-product-key="' + key + '"]').addClass('disabled');
                }
            } else {
                $('a[data-product-key="' + key + '"]').removeClass('can-add');
                $('a[data-product-key="' + key + '"]').addClass('disabled');
                $('body').removeClass('cart-active add');
                alert('There are no more available products');
            }
        }, function (err) {
            Merchello.MUI.Logger.captureError(err);
        });
    });

    $('.continue-shopping').click(function (e) {
        e.preventDefault();
        $('body').removeClass('cart-active add');
    });
}

function initChangeOption() {
    var product = $('a[data-nem="productitem"]');
    $('.product-option input, .product-option select').change(function (e) {
        var index = $(this).data('index');
        if (index != undefined) {
            $(product).data('product-option-' + index, $(this).val());

            var url = '/umbraco/surface/StoreBasket/GetVariant';

            var key = $(product).data('product-key');
            if (key != undefined) {
                url += "?key=" + key;
            }

            for (var i = 0; i < $('.product-option').length; i++) {
                var option = $(product).data('product-option-' + i);
                if (option != undefined) {
                    url += "&options[" + i + "]=" + option;
                }
            }

            $.ajax({
                type: 'GET',
                url: url,
                cache: false,
                success: function (data) {
                    if (data.Success) {
                        $(product).data('product-name', data.VariantName);
                        $(product).data('product-price', data.VariantPrice);
                        $('.product-price').html(data.VariantPrice);
                        if (data.Available) {
                            $(product).data('available', true);

                            if (!$(product).hasClass('can-add')) {
                                $(product).removeClass('disabled');
                                $(product).addClass('can-add');
                                jQuery('body').mobileNav({
                                    menuActiveClass: 'cart-active add',
                                    menuOpener: 'a.can-add, .shop-card-close.added',
                                    hideOnClickOutside: true,
                                    menuDrop: '#headerBasketAdd',
                                    actionOnOpen: 'show'
                                });
                            }
                        } else {
                            $(product).data('available', false);
                            $(product).removeClass('can-add');
                            $(product).addClass('disabled');
                            alert('This product variant is not available to purchase.')
                        }
                    }
                },
                error: function (err) {
                    console.log(err);
                }
            });
        }
    });
}

function initChangeQuantity() {
    $('.input-number').change(function (e) {
        e.preventDefault();
        if (!$.isNumeric($(this).val())) {
            $(this).val($(this).data('current-value'));
            jcf.refresh($(this));
            alert('Not a number!');
        } else {
            updateQuantity($(this), $(this).data('product-key'), $(this).val());
            jcf.refresh($(this));
        }
    });

    $('.input-number').keypress(function (e) {
        var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode == '13') {
            e.preventDefault();
            if (!$.isNumeric($(this).val())) {
                $(this).val($(this).data('current-value'));
                jcf.refresh($(this));
                alert('Not a number!');
            } else {
                updateQuantity($(this), $(this).data('product-key'), $(this).val());
                jcf.refresh($(this));
            }
        }
    });
}

function updateQuantity(button, key, quantity) {
    var url = '/umbraco/surface/StoreBasket/CheckQuantity?key=' + key + '&quantity=' + quantity;
    $.ajax({
        type: 'GET',
        url: url,
        cache: false
    }).then(function (data) {
        if (data.Success) {
            url = '/umbraco/surface/StoreBasket/UpdateQuantity?key=' + key + '&quantity=' + quantity;
            $.ajax({
                type: 'GET',
                url: url,
                cache: false
            }).then(function (data) {
                if (data.Success) {
                    $('strong[data-product-key="' + key + '"]').html(data.ProductQuantityCount);
                    $('td[data-muivalue="linetotal"][data-product-key="' + key + '"] strong').html(data.ProductTotalPrice);

                    var total = $('.shoping-card-block').find('[data-muivalue="total"]');
                    if (total.length > 0) {
                        $(total).html(data.BasketTotalPrice);
                    }

                    $('strong.price').html(data.BasketTotalPrice);

                    var label = $('[data-muilabel="basketcount"]');
                    if (label.length > 0) {
                        $(label).html(data.BasketQuantityCount);
                    }

                    if (data.DonationKey != undefined) {
                        $('td[data-muivalue="linetotal"][data-product-key="' + data.DonationKey + '"] strong').html(data.DonationPrice);
                        $('td[data-muivalue="linetotal"][data-product-key="' + data.DonationKey + '"]').attr('data-product-key', data.NewDonationKey);
                        $('td[data-label="price"][data-product-key="' + data.DonationKey + '"]').html(data.DonationPrice);
                        $('td[data-label="price"][data-product-key="' + data.DonationKey + '"]').attr('data-product-key', data.NewDonationKey);
                    }

                    $.each(data.DiscountUpdates, function (index, item) {
                        $('td[data-muivalue="linetotal"][data-product-key="' + item.DiscountKey + '"] strong').html(item.DiscountTotalPrice);
                        $('td[data-muivalue="linetotal"][data-product-key="' + item.DiscountKey + '"]').attr('data-product-key', item.NewDiscountKey);
                        $('td[data-label="price"][data-product-key="' + item.DiscountKey + '"]').html(item.DiscountTotalPrice);
                        $('td[data-label="price"][data-product-key="' + item.DiscountKey + '"]').attr('data-product-key', item.NewDiscountKey);
                    });

                    $('input[name="item.Quantity"][data-product-key="' + key + '"]').data('current-value', quantity);

                    if (quantity <= 0) {
                        location.reload(true);
                    }
                } else {
                    location.reload(true);
                }
            }, function (err) {
                Merchello.MUI.Logger.captureError(err);
            });
        } else {
            $('html body').trigger('mouseup');
            var input = $('input[name="item.Quantity"][data-product-key="' + key + '"]');
            input.val(input.data('current-value')).change();
            alert('You have exceeded the number of available products, please try a smaller number');
        }
    }, function (err) {
        Merchello.MUI.Logger.captureError(err);
    });
}

function initRemoveProduct() {
    $('.removeProduct').click(function (e) {
        e.preventDefault();
        removeProduct($(this).data('product-key'));
    });
}

function removeProduct(key) {
    var url = '/umbraco/surface/StoreBasket/RemoveProduct?key=' + key;
    $.ajax({
        type: 'GET',
        url: url,
        cache: false
    }).then(function (data) {
        var total = $('.shoping-card-block').find('[data-muivalue="total"]');
        if (total.length > 0) {
            $(total).html(data.BasketTotalPrice);
        }

        $('strong.price').html(data.BasketTotalPrice);

        var label = $('[data-muilabel="basketcount"]');
        if (label.length > 0) {
            $(label).html(data.BasketQuantityCount);
        }

        $.each(data.DiscountUpdates, function (index, item) {
            $('td[data-muivalue="linetotal"][data-product-key="' + item.DiscountKey + '"] strong').html(item.DiscountTotalPrice);
            $('td[data-muivalue="linetotal"][data-product-key="' + item.DiscountKey + '"]').attr('data-product-key', item.NewDiscountKey);
            $('td[data-label="price"][data-product-key="' + item.DiscountKey + '"]').html(item.DiscountTotalPrice);
            $('td[data-label="price"][data-product-key="' + item.DiscountKey + '"]').attr('data-product-key', item.NewDiscountKey);
        });

        location.reload(true);
    }, function (err) {
        Merchello.MUI.Logger.captureError(err);
    });
}

function initApplyDiscount() {
    $('a[data-function="apply-discount"]').click(function (e) {
        e.preventDefault();
        var offerCode = $('input[name="voucher"]').val();
        var url = '/umbraco/surface/StoreBasket/ApplyDiscount?offerCode=' + offerCode;
        $.ajax({
            type: 'GET',
            url: url,
            cache: false
        }).then(function (data) {
            if (data.Success) {
                location.reload(true);
            } else {
                $('#voucher-message').addClass('text-danger');
                $('#voucher-message').html(data.Exception.Message);
            }
        }, function (err) {
            Merchello.MUI.Logger.captureError(err);
        });
    });

    $('input[name="voucher"]').keypress(function (e) {
        if (e.keyCode == 13) {
            $('[data-function="apply-discount"]').trigger('click');
        }
    });
}

function initAddressLookup() {
    $('#noAddress').hide();

    $('input[name="AddressSearch"]').keypress(function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            $('a#findAddress').click();
        }
    });

    $('a#findAddress').click(function (e) {
        e.preventDefault();
        var pcode = $('input[name="AddressSearch"]').val();

        if (pcode != '') {
            var url = '/umbraco/surface/AddressLookup/GetAddresses?postcode=' + pcode;
            $.ajax({
                type: 'GET',
                url: url,
                cache: false
            }).then(function (data) {
                if (data.length > 0) {
                    var selectOptions = '';
                    $.each(data, function (index, item) {
                        selectOptions += '<option value="' + item.Value + '">' + item.Summary + '</option>';
                    });
                    $('#addressSelect').html(selectOptions);
                    $('#noAddress').hide();
                    $('#addressSelect').show();
                    jcf.refreshAll();
                } else {
                    $('#addressSelect').html('');
                    $('#noAddress').show();
                    $('#addressSelect').hide();
                    jcf.refreshAll();
                }
            }, function (err) {
                console.log(err);
            });
        } else {
            $('#addressSelect').html('');
            $('#noAddress').show();
            $('#addressSelect').hide();
            jcf.refreshAll();
        }
    });

    $('select#addressSelect').change(function (e) {
        var pKey = $(this).val();
        var url = '/umbraco/surface/AddressLookup/SelectAddress?addressId=' + pKey;
        $.ajax({
            type: 'GET',
            url: url,
            cache: false
        }).then(function (data) {
            if (data) {
                $('#Address1').val(data.AddressOne);
                $('#Address2').val(data.AddressTwo);
                $('#Locality').val(data.Town);
                $('#Region').val(data.County);
                $('#PostCode').val(data.Postcode);
                var validator = $('.address-form').validate();
                if (validator !== undefined) {
                    if (validator.element('#Address1')) {
                        jQuery('#Address1').closest('.form-group').removeClass('input-error');
                    }
                    if (validator.element('#Address2')) {
                        jQuery('#Address2').closest('.form-group').removeClass('input-error');
                    }
                    if (validator.element('#Locality')) {
                        jQuery('#Locality').closest('.form-group').removeClass('input-error');
                    }
                    if (validator.element('#Region')) {
                        jQuery('#Region').closest('.form-group').removeClass('input-error');
                    }
                    if (validator.element('#PostCode')) {
                        jQuery('#PostCode').closest('.form-group').removeClass('input-error');
                    }
                }
                validator = $('.form-validation').validate();
                if (validator !== undefined) {
                    if (validator.element('#Address1')) {
                        jQuery('#Address1').closest('.form-group').removeClass('input-error');
                    }
                    if (validator.element('#Address2')) {
                        jQuery('#Address2').closest('.form-group').removeClass('input-error');
                    }
                    if (validator.element('#Locality')) {
                        jQuery('#Locality').closest('.form-group').removeClass('input-error');
                    }
                    if (validator.element('#Region')) {
                        jQuery('#Region').closest('.form-group').removeClass('input-error');
                    }
                    if (validator.element('#PostCode')) {
                        jQuery('#PostCode').closest('.form-group').removeClass('input-error');
                    }
                }
            }
        }, function (err) {
            console.log(err);
        });
    });

    $('input[name="address"]').change(function (e) {
        if (this.checked) {
            var line1 = $(this).data('line1');
            if (line1 != undefined) {
                $('#Address1').val(line1);
            }

            var line2 = $(this).data('line2');
            if (line2 != undefined) {
                $('#Address2').val(line2);
            }

            var line3 = $(this).data('line3');
            if (line3 != undefined) {
                $('#Address3').val(line3);
            }

            var city = $(this).data('city');
            if (city != undefined) {
                $('#Locality').val(city);
            }

            var county = $(this).data('county');
            if (county != undefined) {
                $('#Region').val(county);
            }

            var postcode = $(this).data('postcode');
            if (postcode != undefined) {
                $('#PostCode').val(postcode);
            }
        }
    });

    // main address

    $('#noAddressMain').hide();

    $('input[name="AddressSearchMain"]').keypress(function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            $('a#findAddressMain').click();
        }
    });

    $('a#findAddressMain').click(function (e) {
        e.preventDefault();
        var pcode = $('input[name="AddressSearchMain"]').val();

        if (pcode != '') {
            var url = '/umbraco/surface/AddressLookup/GetAddresses?postcode=' + pcode;
            $.ajax({
                type: 'GET',
                url: url,
                cache: false
            }).then(function (data) {
                if (data.length > 0) {
                    var selectOptions = '';
                    $.each(data, function (index, item) {
                        selectOptions += '<option value="' + item.Value + '">' + item.Summary + '</option>';
                    });
                    $('#addressSelectMain').html(selectOptions);
                    $('#noAddressMain').hide();
                    $('#addressSelectMain').show();
                    jcf.refreshAll();
                } else {
                    $('#addressSelectMain').html('');
                    $('#noAddressMain').show();
                    $('#addressSelectMain').hide();
                    jcf.refreshAll();
                }
            }, function (err) {
                console.log(err);
            });
        } else {
            $('#addressSelectMain').html('');
            $('#noAddressMain').show();
            $('#addressSelectMain').hide();
            jcf.refreshAll();
        }
    });

    $('select#addressSelectMain').change(function (e) {
        var pKey = $(this).val();
        var url = '/umbraco/surface/AddressLookup/SelectAddress?addressId=' + pKey;
        $.ajax({
            type: 'GET',
            url: url,
            cache: false
        }).then(function (data) {
            if (data) {
                $('#Address1Main').val(data.AddressOne);
                $('#Address2Main').val(data.AddressTwo);
                $('#LocalityMain').val(data.Town);
                $('#RegionMain').val(data.County);
                $('#PostCodeMain').val(data.Postcode);
                var validator = $('.generic-form.popup-form').validate();
                if (validator !== undefined) {
                    if (validator.element('#Address1Main')) {
                        jQuery('#Address1Main').closest('.form-group').removeClass('input-error');
                    }
                    if (validator.element('#Address2Main')) {
                        jQuery('#Address2Main').closest('.form-group').removeClass('input-error');
                    }
                    if (validator.element('#LocalityMain')) {
                        jQuery('#LocalityMain').closest('.form-group').removeClass('input-error');
                    }
                    if (validator.element('#RegionMain')) {
                        jQuery('#RegionMain').closest('.form-group').removeClass('input-error');
                    }
                    if (validator.element('#PostCodeMain')) {
                        jQuery('#PostCodeMain').closest('.form-group').removeClass('input-error');
                    }
                }
            }
        }, function (err) {
            console.log(err);
        });
    });
}

function initDonation() {
    $('input#donate').change(function () {
        var isAdd = $(this)[0].checked;
        var url = '/umbraco/surface/StoreBasket/' + (isAdd ? 'AddDonation' : 'RemoveDiscount');
        $.ajax({
            type: 'GET',
            url: url,
            cache: false
        }).then(function (data) {
            if (data.Success) {
                location.reload(true);
            } else {
                alert("ERROR");
            }
        }, function (err) {
            Merchello.MUI.Logger.captureError(err);
        });
    });
}

function initGiftAid() {
    $('input#giftAid').change(function () {
        var isAdd = $(this)[0].checked;
        var url = '/umbraco/surface/StoreBasket/' + (isAdd ? 'AddGiftAid' : 'RemoveGiftAid');
        $.ajax({
            type: 'GET',
            url: url,
            cache: false
        }).then(function (data) {
            if (data.Success) {
                location.reload(true);
            } else {
                alert("ERROR");
            }
        }, function (err) {
            Merchello.MUI.Logger.captureError(err);
        });
    });
}

/*
 * End of Shop functions
 */

function initAdditionalValidation() {
    $.validator.unobtrusive.adapters.add('requiredif', ['dependentproperty', 'desiredvalue'], function (options) {
        options.rules['requiredif'] = options.params;
        options.messages['requiredif'] = options.message;
    });

    $.validator.addMethod('requiredif', function (value, element, parameters) {
        var desiredvalue = parameters.desiredvalue;
        desiredvalue = (desiredvalue == null ? '' : desiredvalue).toString();
        var controlType = $("input[id$='" + parameters.dependentproperty + "']").attr("type");
        var actualvalue = {}
        if (controlType == "checkbox" || controlType == "radio") {
            var control = $("input[id$='" + parameters.dependentproperty + "']:checked");
            actualvalue = control.val();
        } else {
            actualvalue = $("#" + parameters.dependentproperty).val();
        }
        if ($.trim(desiredvalue).toLowerCase() === $.trim(actualvalue).toLocaleLowerCase()) {
            var isValid = $.validator.methods.required.call(this, value, element, parameters);
            return isValid;
        }
        return true;
    });
}

function initEditForm() {
    var blockHolder = jQuery('.has-edit');
    var tabFrame = jQuery('.tab-frame');

    blockHolder.each(function () {
        var self = jQuery(this);
        var inputs = self.find('.form-control');
        var editBtn = self.find('.btn');

        inputs.attr('readonly', 'readonly');

        editBtn.on('click', function (e) {
            e.preventDefault();

            inputs.removeAttr('readonly');
        });
    });

    tabFrame.each(function () {
        var self = jQuery(this);
        editTabForm(self);

        if (jQuery(this).find('.field-validation-error').length > 0) {
            jQuery(this).find('.btn-save').trigger('click');
        }
    })

    function editTabForm(self) {
        var editActive = 'edit-active';
        var inputs = self.find('.form-control');
        var editBtn = self.find('.btn-save');
        var cancelBtn = self.find('.btn-cancel');
        var editPwdBtn = self.find('.btn-save-pwd');
        var cancelPwdBtn = self.find('.btn-cancel-pwd');
        var formGroup = self.find('.check-error');
        var inputControl = formGroup.find('.form-control, .jcf-select-normal-select .jcf-select-text');
        var isChecked = false;
        var fieldsValue = [];
        inputs.attr('readonly', 'readonly');
        cancelBtn.hide();
        cancelPwdBtn.hide();

        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }

        function getField() {
            fieldsValue = [];
            inputControl = self.find('.form-control, .jcf-select-normal-select .jcf-select-text');

            self.find('.jcf-select-normal-select .jcf-select-text').each(function () {
                var self = jQuery(this);
                var fakeSpanHolder = self.closest('.jcf-select-text');
                var isFakeSpan = fakeSpanHolder.find('span').hasClass('fake-span');
            
                if (!isFakeSpan) {
                    var initValue = fakeSpanHolder.find('span:first').text().trim();
                    fakeSpanHolder.append('<span class="fake-span">' + initValue + '</span>');
                }
            });
            

            inputControl.each(function () {
                var self = jQuery(this);
                var fakeSpanHolder = self.closest('.jcf-select-text');
                var fakeSpanField = fakeSpanHolder.find('.fake-span');
                var id = self.attr('id');
                var value = self.val();

                if (self.hasClass('jcf-select-text')) {
                    id = self.closest('.form-group').find('select').attr('id');
                    value = self.find('span:first').text().trim();
                    fakeSpanField.text(value);
                }

                fieldsValue.push({
                    id: id,
                    value: value
                })
            });
        }

        getField();

        function resetField() {
            inputControl = self.find('.form-control, .jcf-select-normal-select .jcf-select-text');
            inputControl.each(function () {
                var input = jQuery(this);
                var id = input.attr('id');
                input.closest('.form-group').removeClass('input-error');

                if (input.hasClass('jcf-select-text')) {
                    id = input.closest('.form-group').find('select').attr('id');
                }

                fieldsValue.map(function (item) {
                    if (item.id == id) {
                        if (input.hasClass('jcf-select-text')) {
                            var select = input.closest('.form-group').find('select');
                            select.val(item.value);
                        }
                    }
                });

                jcf.refreshAll();

                fieldsValue.map(function (item) {
                    if (item.id == id) {
                        input.val(item.value);

                        if (input.hasClass('jcf-select-text')) {
                            input.find('.fake-span').text(item.value);
                        }
                    }
                });
            });
        }

        self.find('.pwd-control-field').hide();
        self.find('.pwd-control-label').hide();
        self.find('.pwd-btns').hide();

        self.find('.address-label').hide();
        self.find('.address-list').hide();
        self.find('.address-different').hide();
        self.find('.address-select-block').hide();

        function checkAddressInputs() {
            var hasAnyValues = false;

            inputControl = self.find('.contact-col').find('.form-control, .jcf-select-normal-select .jcf-select-text');

            if (inputControl.length > 0) {
                inputControl.each(function () {
                    var input = jQuery(this);
                    if (input.val() != '' && !hasAnyValues) {
                        hasAnyValues = true;
                    }
                });

                // if we have any values then we need to add the asterisks and check-error classes to the required address fields
                inputControl.each(function () {
                    var input = jQuery(this);
                    if (this.id == 'Address1' || this.id == 'Locality' || this.id == 'PostCode') {
                        if (hasAnyValues && !input.closest('.form-group').hasClass('check-error')) {
                            input.closest('.form-group').addClass('check-error');
                            input.siblings('label').after('&nbsp;<sup class="text-danger">*</sup>')
                        } else if (!hasAnyValues) {
                            input.closest('.form-group').removeClass('check-error');
                            input.closest('.form-group').removeClass('input-error');
                            input.siblings('sup.text-danger').remove();
                            input.siblings('.error-text').removeClass('field-validation-error');
                            input.siblings('.error-text').addClass('field-validation-valid');
                        }
                    }
                });
            }
        }

        inputControl.focus(function () {
            if (jQuery(this).val() != '' && !jQuery(this).attr('readonly') && jQuery(this).closest('.form-group').hasClass('check-error')) {
                jQuery(this).closest('.form-group').removeClass('input-error');
            }
        }).blur(function () {
            checkAddressInputs();
            if (jQuery(this).val() == '' && !jQuery(this).attr('readonly') && jQuery(this).closest('.form-group').hasClass('check-error')) {
                jQuery(this).closest('.form-group').addClass('input-error');
            }
        });

        editBtn.on('click', function (e) {
            e.preventDefault();
            inputs.removeAttr('readonly');
            self.find('.pwd-control-label').show();
            self.find('.pwd-btns').show();

            self.find('.address-label').show();
            self.find('.address-list').show();
            self.find('.address-different').show();
            self.find('.address-select-block').show();
            $('input[name="AddressSearch"]').val('');
            $('#addressSelect').html('');
            $('#addressSelect').hide();
            $('#noAddress').hide();
            jcf.refreshAll();

            if (self.hasClass(editActive)) {
                if (self.hasClass('edit-pwd') || self.hasClass('validate-this-only')) {
                    formGroup = self.find('.check-error');
                    inputControl = formGroup.find('.form-control, .jcf-select-normal-select .jcf-select-text');
                }

                inputControl.each(function () {
                    var $this = jQuery(this);

                    if ($this.val() == '' && $this.data('required')) {
                        $this.closest('.form-group').addClass('input-error');
                    } else {
                        $this.closest('.form-group').removeClass('input-error');

                        if ($this.attr('type') == 'email') {
                            if (validateEmail($this.val())) {
                                $this.closest('.form-group').removeClass('input-error');
                            } else {
                                $this.closest('.form-group').addClass('input-error');
                            }
                        }
                    }

                    if ($this.hasClass('jcf-select-text')) {
                        var dropDown = $this.closest('.form-group').find('select');
                        if (dropDown.val() == '' && dropDown.data('required')) {
                            $this.closest('.form-group').addClass('input-error');
                        }
                    }
                });

                isChecked = formGroup.hasClass('input-error');
                if (!isChecked) {
                    function submit() {
                        var panelName = $(self).attr('name');
                        dataLayer.push({ event: "member-detail-edit", "member-detail-edit-action": "Save", "member-detail-edit-panel-name": panelName });
                        jQuery(self).find('input[type="submit"]').trigger('click');
                        getField();
                        if (self.find('.field-validation-error').length == 0) {
                            self.removeClass(editActive);
                            self.removeClass('validate-this-only');
                            self.find('.pwd-control-field').hide();
                            self.find('.pwd-control-label').hide();
                            self.find('.pwd-btns').hide();

                            self.find('.address-label').hide();
                            self.find('.address-list').hide();
                            self.find('.address-different').hide();
                            self.find('.address-select-block').hide();
                            inputs.attr('readonly', 'readonly');
                            jQuery(self).find('.btn-save .text').text('Edit');

                            if ($('[name="fromProfileTab"]').val() == '1') {
                                setTimeout(function () {
                                    location.reload(true);
                                }, 500);
                            }

                            return;
                        }
                    }

                    if (formGroup.find('.emailexists').length > 0) {
                        var warning = $(formGroup.find('.emailexists')[0]);
                        if (warning.siblings('.form-control')[0].name.indexOf("EmailAddress") >= 0) {
                            if (warning.siblings('.form-control')[0].value != warning.siblings('.form-control')[0].dataset.originalValue) {
                                $.ajax({
                                    url: '/Umbraco/Api/MembersValidationApi/EmailExists?emailAddress=' + warning.siblings('.form-control')[0].value,
                                    dataType: 'json'
                                }).then(function (e) {
                                    if (e.data != null) {
                                        warning[0].innerHTML = e.data;
                                        $(warning[0]).addClass('field-validation-error');
                                        $(warning[0]).removeClass('field-validation-valid');
                                    } else {
                                        warning[0].innerHTML = "";
                                        $(warning[0]).addClass('field-validation-valid');
                                        $(warning[0]).removeClass('field-validation-error');

                                        submit();
                                    }
                                });
                            } else {
                                submit();
                            }
                        }
                    } else {
                        submit();
                    }
                }
            } else {
                var panelName = $(self).attr('name');
                dataLayer.push({ event: "member-detail-edit", "member-detail-edit-action": "Edit", "member-detail-edit-panel-name": panelName });
                self.addClass('validate-this-only');
                self.addClass(editActive);
                jQuery(this).find('.text').text('Save');
                cancelBtn.show();
                editPwdBtn.show();
            }
        });

        cancelBtn.on('click', function (e) {
            var panelName = $(self).attr('name');
            dataLayer.push({ event: "member-detail-edit", "member-detail-edit-action": "Cancel", "member-detail-edit-panel-name": panelName });
            e.preventDefault();
            if (formGroup.find('.emailexists').length > 0) {
                var warning = $(formGroup.find('.emailexists')[0]);
                warning[0].innerHTML = "";
                $(warning[0]).addClass('field-validation-valid');
                $(warning[0]).removeClass('field-validation-error');
            }

            self.find('.pwd-control-label').hide();
            self.find('.pwd-control-field').hide();
            self.find('.pwd-btns').hide();

            self.find('.address-label').hide();
            self.find('.address-list').hide();
            self.find('.address-different').hide();
            self.find('.address-select-block').hide();
            resetField();
            jQuery(this).closest('.btn-list').find('.btn-save .text').text('Edit');
            jQuery('.pwd-btns').find('.btn-save-pwd .text').text('Change Password');
            self.removeClass(editActive);
            self.removeClass('validate-this-only');
            self.removeClass('edit-pwd');
            cancelBtn.hide();
            editPwdBtn.hide();
            cancelPwdBtn.hide();
            $('#ValidatePassword').val('False');
            inputs.attr('readonly', 'readonly');
        });

        editPwdBtn.on('click', function (e) {
            e.preventDefault();
            inputs.removeAttr('readonly');

            if (self.hasClass(editActive) && self.hasClass('edit-pwd')) {
                self.find('.pwd-control-field .form-control').each(function () {
                    var $this = jQuery(this);

                    if ($this.val() == '' && $this.data('required')) {
                        $this.closest('.form-group').addClass('input-error');
                    } else {
                        $this.closest('.form-group').removeClass('input-error');

                        if ($this.attr('type') == 'email') {
                            if (validateEmail($this.val())) {
                                $this.closest('.form-group').removeClass('input-error');
                            } else {
                                $this.closest('.form-group').addClass('input-error');
                            }
                        }
                    }
                });

                formGroup = self.find('.check-error');
                isChecked = formGroup.hasClass('input-error');
                if (!isChecked) {
                    jQuery(this).siblings('input[type="submit"]').trigger('click');
                    getField();
                    self.removeClass('edit-pwd');
                    inputs.attr('readonly', 'readonly');
                    jQuery(this).find('.text').text('Change Password');
                }
            } else {
                self.find('.pwd-control-label').hide();
                self.find('.pwd-control-field').show();
                self.find('.pwd-control-field').addClass('check-error');
                self.addClass('edit-pwd');
                jQuery(this).find('.text').text('Save');
                editPwdBtn.hide();
                $('#ValidatePassword').val('True');
            }
        });
    }
}

function initFormState() {
    var win = jQuery(window);
    var stateForm = jQuery('.state-form');
    var saveBtn = stateForm.find('.btn-radio-save');
    var resetBtn = stateForm.find('.btn-radio-cancel');
    var makeFieldActive = true;
    var addressHolder = jQuery('.address-area');
    var altAddressHolder = jQuery('.address-list');
    var shopAddressHolder = jQuery('.address-lookup .address-holder .radio-list');

    if (makeFieldActive) {
        stateForm.addClass('edit-active');
    }

    function setLocalData() {
        var radioListItem = stateForm.find('li').has('.custom-radio');
        var inputSelect = stateForm.find('.border-list .jcf-select-text span').text();
        var seletedValue = [];

        for (var i = 0; i <= radioListItem.length - 1; i++) {
            var inputRadioName = radioListItem.eq(i).find('input').attr('name');
            var radioValue = radioListItem.eq(i).find('input[name="' + inputRadioName + '"]:checked').val();

            if (radioValue == null || radioValue == undefined) {
                radioValue = 'No';
            }
            seletedValue.push({
                inputRadioName: inputRadioName,
                radioValue: radioValue
            });
        }

        var checkboxItem = stateForm.find('li').has('.custom-check');
        var seletedCheckboxValue = [];

        for (var i = 0; i <= checkboxItem.length - 1; i++) {
            var inputCheckboxName = checkboxItem.eq(i).find('input').attr('name');
            var checkValue = checkboxItem.eq(i).find('input[name="' + inputCheckboxName + '"]:checked').val();

            if (checkValue == null || checkValue == undefined) {
                checkValue = 'No';
            }
            seletedCheckboxValue.push({
                inputCheckboxName: inputCheckboxName,
                checkValue: checkValue
            });
        }

        localStorage.setItem('communicationPreferences', JSON.stringify(seletedValue));
        localStorage.setItem('checkboxes', JSON.stringify(seletedCheckboxValue));
        localStorage.setItem('updateTime', inputSelect);
    }

    function checkInputStates() {
        var radioListItem = stateForm.find('li').has('.custom-radio');
        radioListItem.find('input[type="radio"]').prop('checked', false);
        var checkListItem = stateForm.find('li').has('.custom-check');
        checkListItem.find('input[type="checkbox"]').prop('checked', false);
        getFormStates();

        radioListItem.each(function () {
            var $this = jQuery(this);
            var inputRadio = $this.find('.custom-radio input');
            var inputRadioName = inputRadio.attr('name');
            var checkedState = $this.find('.custom-radio input[name="' + inputRadioName + '"]:checked').val();
            if (checkedState == undefined) {
                checkedState = 'no';
            }

            if (checkedState.toLowerCase() == 'true') {
                $this.addClass('success');
                $this.removeClass('error');
            } else {
                $this.removeClass('success');
                $this.addClass('error');
            }
        });

        checkListItem.each(function () {
            var $this = jQuery(this);
            var inputCheck = $this.find('.custom-check input');
            var checkedState = inputCheck.attr('checked');
            if (checkedState == undefined) {
                checkedState = 'no';
            }

            if (checkedState.toLowerCase() == 'checked') {
                $this.addClass('success');
                $this.removeClass('error');
            } else {
                $this.removeClass('success');
                $this.addClass('error');
            }
        });
    }

    function getFormStates() {
        var localData = JSON.parse(localStorage.getItem('communicationPreferences'));
        var localCheckboxData = JSON.parse(localStorage.getItem('checkboxes'));
        var updateTime = localStorage.getItem('updateTime');
        var radioListItem = stateForm.find('.border-list li').has('.custom-radio');
        var checkboxItem = stateForm.find('.border-list li').has('.custom-check');

        if (updateTime) {
            stateForm.find('.selected-value').text(updateTime);
        }

        if (localData) {
            for (var i = 0; i < localData.length; i++) {
                var radioName = localData[i].inputRadioName;
                var checkedField = localData[i].radioValue;
                var inputRadio = radioListItem.eq(i).find('input');
                var inputRadioName = radioListItem.eq(i).find('input').attr('name');

                if (inputRadioName == radioName) {
                    if (checkedField.toLowerCase() == 'no') {
                        jQuery("input[name='" + radioName + "'][value='" + checkedField + "']").prop('checked', false);
                    } else {
                        jQuery("input[name='" + radioName + "'][value='" + checkedField + "']").prop('checked', true);
                    }
                }
            }
        }

        if (localCheckboxData) {
            for (var i = 0; i < localCheckboxData.length; i++) {
                var checkName = localCheckboxData[i].inputCheckboxName;
                var checkedField = localCheckboxData[i].checkValue;
                var inputCheck = checkboxItem.eq(i).find('input');
                var inputCheckboxName = checkboxItem.eq(i).find('input').attr('name');

                if (inputCheckboxName == checkName) {
                    if (checkedField.toLowerCase() == 'no') {
                        jQuery("input[name='" + checkName + "'][value='" + checkedField + "']").prop('checked', false);
                    } else {
                        jQuery("input[name='" + checkName + "'][value='" + checkedField + "']").prop('checked', true);
                    }
                }
            }
        }
    }

    saveBtn.on('click', function (e) {
        e.preventDefault();
        var self = jQuery(this);
        var textBtn = self.find('.text');
        stateForm.toggleClass('edit-active');

        if (textBtn.text().toLowerCase() == 'save') {
            var panelName = $(stateForm).attr('name');
            dataLayer.push({ event: "member-detail-edit", "member-detail-edit-action": "Save", "member-detail-edit-panel-name": panelName });
            jQuery(this).siblings('input[type="submit"]').trigger('click');
            textBtn.text('Edit');
            setLocalData();
            checkInputStates();
        } else {
            var panelName = $(stateForm).attr('name');
            dataLayer.push({ event: "member-detail-edit", "member-detail-edit-action": "Edit", "member-detail-edit-panel-name": panelName });
            textBtn.text('Save');
            return false;
        }
    });

    resetBtn.on('click', function (e) {
        var panelName = $(stateForm).attr('name');
        dataLayer.push({ event: "member-detail-edit", "member-detail-edit-action": "Cancel", "member-detail-edit-panel-name": panelName });
        e.preventDefault();
        saveBtn.find('.text').text('Edit');
        stateForm.removeClass('edit-active');
        checkInputStates();
    });

    setLocalData();
    win.on('load', checkInputStates);
    resetBtn.click();
    btnclick();
    
    function btnclick() {
        var addressOpener = jQuery('.address-opener, .address-block .btn-edit');
        var addressDeletetBtn = jQuery('.address-block').find('.btn-delete');

        addressOpener.unbind('click').on('click', function (e) {
            var self = jQuery(this);
            e.preventDefault();
            fancyboxOpen(self);
            jQuery('.generic-form.popup-form .form-group').removeClass('input-error');
            jQuery('.generic-form.popup-form .form-control').removeClass('field-validation-error');
            jQuery('.generic-form.popup-form .error-text').removeClass('field-validation-error');
            jcf.refreshAll();
        });

        addressDeletetBtn.unbind('click').on('click', function (e) {
            var success = false;
            var btn = $(this);

            e.preventDefault(); $.ajax({
                url: jQuery(this).attr('href'),
                error: function (jqXHR, textStatus, errorThrown) {
                },
                success: function (result, textStatus, jqXHR) {
                    dataLayer.push({ event: "member-addresses-edit", "member-addresses-edit-action": "Delete" });
                    success = true;
                },
                complete: function (jqXHR, textStatus) {
                    if (success) {
                        btn.closest('.address-block').remove();
                    }
                }
            });
        });
    }

    function fancyboxOpen(self) {
        $.fancybox({
            type: 'inline',
            openEffect: 'fade',
            closeEffect: 'fade',
            openSpeed: 'fast',
            wrapCSS: 'address-lightbox',
            height: 'auto',
            beforeShow: function () {
                jQuery('.fancybox-overlay').addClass('address-fancybox');
            },
            beforeLoad: function () {
                this.content = jQuery('.generic-form.popup-form.address-form');
                jQuery('.generic-form.popup-form .form-group').removeClass('input-error');

                $('input[name="AddressSearchMain"]').val('');
                $('#addressSelectMain').html('');
                $('#addressSelectMain').hide();
                $('#noAddressMain').hide();
                jcf.refreshAll();
            },
            afterLoad: function (instance, current) {
                var inputList = [];
                var lightboxInputList = [];
                var element = instance.content;
                var formLightBoxFormGroup = element.find('.form-group.check-error');

                function setFormData(holder) {
                    var inputs = holder.find('.address-list li');
                    for (var i = 0; i < inputs.length; i++) {
                        var key = inputs.eq(i).attr('class');
                        var value = inputs.eq(i).text();
                        inputList.push({
                            key: key,
                            value: value
                        });
                    }

                    inputList.map(function (item) {
                        var lightboxInput = element.find("#" + item.key);
                        var id = lightboxInput.attr('id');

                        if (item.key == id) {
                            lightboxInput.val(item.value);
                        }
                    });
                }

                if (self.hasClass('btn-edit')) {
                    var holder = self.closest('.holder');
                    setFormData(holder)
                }

                formLightBoxFormGroup.find('input').not(':input[type=button], :input[type=submit], :input[type=reset]').focus(function () {
                    if (jQuery(this).val() != '' && jQuery(this).data('required')) {
                        jQuery(this).closest('.form-group').removeClass('input-error');
                    }
                }).blur(function () {
                    if (jQuery(this).val() == '' && jQuery(this).data('required')) {
                        jQuery(this).closest('.form-group').addClass('input-error');
                    }
                });

                var lightboxBtnSave = instance.content.find('.btn-save');
                var lightboxBtnCancel = instance.content.find('.btn-cancel');
                var tpl = '';

                function fancyclose() {
                    instance.content.find('.form-control').val('');
                    $.fancybox.close(true);
                }

                lightboxBtnSave.unbind('click').on('click', function (e) {
                    e.preventDefault();

                    function renderToDom() {
                        var lightboxInput = element.find('.form-group');
                        for (var i = 0; i < lightboxInput.length; i++) {
                            var key = lightboxInput.eq(i).find('input').attr('id');
                            var value = lightboxInput.eq(i).find('input').val();
                            lightboxInputList.push({
                                key: key,
                                value: value
                            });
                        }
                    }
                    renderToDom();

                    function checkInputError() {
                        var inputControl = formLightBoxFormGroup.find('.form-control');

                        inputControl.each(function () {
                            var $this = jQuery(this);

                            if ($this.val() == '') {
                                $this.closest('.form-group').addClass('input-error');
                            } else {
                                $this.closest('.form-group').removeClass('input-error');
                            }
                        });

                        inputControl.focus(function () {
                            if (jQuery(this).val != '') {
                                jQuery(this).closest('.form-group').removeClass('input-error');
                            }
                        }).blur(function () {
                            if (jQuery(this).val = '') {
                                jQuery(this).closest('.form-group').addClass('input-error');
                            }
                        });
                    }

                    tpl = '<div class="address-block"><div class="holder"><ul class="address-list">' +
                        lightboxInputList.map(function (item) {
                            return "<li class=" + item.key + ">" + item.value + "</li>";
                        }).join(' ') + '</ul><ul class="btn-list"><li><a href="#" class="btn btn-light-yellow btn-edit"><div class="text">Edit</div><span class="icon-arrow-circle-right"></span></a></li><li><a href="#" class="btn btn-light-yellow btn-delete">Delete<span class="icon-delete"></span></a></li></ul></div></div>';

                    if (self.hasClass('address-opener')) {
                        checkInputError();
                        var isChecked = formLightBoxFormGroup.hasClass('input-error');
                        if (!isChecked) {
                            dataLayer.push({ event: "member-addresses-edit", "member-addresses-edit-action": "Add" });
                            jQuery(this).siblings('input[type="submit"]').trigger('click');
                            var LineOne = '';
                            var LineTwo = '';
                            var LineThree = '';
                            var City = '';
                            var County = '';
                            var PostCode = '';

                            lightboxInputList.map(function (item) {
                                switch (item.key) {
                                    case 'Address1Main':
                                        LineOne = item.value;
                                        break;
                                    case 'Address2Main':
                                        LineTwo = item.value;
                                        break;
                                    case 'Address3Main':
                                        LineThree = item.value;
                                        break;
                                    case 'LocalityMain':
                                        City = item.value;
                                        break;
                                    case 'RegionMain':
                                        County = item.value;
                                        break;
                                    case 'PostCodeMain':
                                        PostCode = item.value;
                                        break;
                                }
                            });

                            if (addressHolder.length > 0) {
                                addressHolder.append(tpl);
                            } else if (altAddressHolder.length > 0) {
                                tpl = '<li>' +
                                    '<label for="address-' + PostCode + '" class="custom-radio">' +
                                    '<input id="address-' + PostCode + '" type="radio" name="address" data-line1="' + LineOne + '" data-line2="' + LineTwo + '" data-line3="' + LineThree + '" data-city="' + City + '" data-county="' + County + '" data-postcode="' + PostCode + '">' +
                                    '<span class="custom-input"></span>' +
                                    '<span class="custom-label">' + LineOne + ', ' + LineTwo + ', ' + City + ', ' + County + ' ' + PostCode + '</span>' +
                                    '</label>' +
                                    '</li>';
                                altAddressHolder.append(tpl);

                                initAddressLookup();
                            } else if (shopAddressHolder.length > 0) {
                                tpl = '<li>' +
                                    '<label for="address-' + PostCode + '" class="custom-radio">' +
                                    '<input id="address-' + PostCode + '" type="radio" name="address" data-line1="' + LineOne + '" data-line2="' + LineTwo + '" data-line3="' + LineThree + '" data-city="' + City + '" data-county="' + County + '" data-postcode="' + PostCode + '">' +
                                    '<span class="custom-input"></span>' +
                                    '<span class="custom-label">' + LineOne + ', ' + LineTwo + ', ' + City + ', ' + County + ' ' + PostCode + '</span>' +
                                    '</label>' +
                                    '</li>';
                                shopAddressHolder.append(tpl);

                                initAddressLookup();
                            } else if (jQuery('.address-lookup').length > 0) {
                                tpl = '<div class="address-holder"><strong>Use an existing address:</strong>' +
                                    '<ul class="radio-list">' +
                                    '<li>' +
                                    '<label for="address-' + PostCode + '" class="custom-radio">' +
                                    '<input id="address-' + PostCode + '" type="radio" name="address" data-line1="' + LineOne + '" data-line2="' + LineTwo + '" data-line3="' + LineThree + '" data-city="' + City + '" data-county="' + County + '" data-postcode="' + PostCode + '">' +
                                    '<span class="custom-input"></span>' +
                                    '<span class="custom-label">' + LineOne + ', ' + LineTwo + ', ' + City + ', ' + County + ' ' + PostCode + '</span>' +
                                    '</label>' +
                                    '</li>' +
                                    '</ul></div>';
                                jQuery(tpl).insertAfter('.address-lookup .text-title');

                                initAddressLookup();
                            } else {
                                tpl = '<span class="label address-label">Use an existing address:</span>' +
                                    '<ul class="radio-list address-list">' +
                                        '<li>' +
                                            '<label for="address-' + PostCode + '" class="custom-radio">' +
                                                '<input id="address-' + PostCode + '" type="radio" name="address" data-line1="' + LineOne + '" data-line2="' + LineTwo + '" data-line3="' + LineThree + '" data-city="' + City + '" data-county="' + County + '" data-postcode="' + PostCode + '">' +
                                                '<span class="custom-input"></span>' +
                                                '<span class="custom-label">' + LineOne + ', ' + LineTwo + ', ' + City + ', ' + County + ' ' + PostCode + '</span>' +
                                            '</label>' +
                                        '</li>' +
                                    '</ul>';
                                jQuery(tpl).insertBefore('.address-opener');

                                initAddressLookup();
                            }
                            btnclick();
                            fancyclose();
                        }
                        return;

                    } if (self.hasClass('btn-edit')) {
                        checkInputError();
                        var isChecked = formLightBoxFormGroup.hasClass('input-error');
                        if (!isChecked) {
                            jQuery(this).siblings('input[type="submit"]').trigger('click');
                            holder.find('.address-list').html(
                                lightboxInputList.map(function (item) {
                                    return (item.value ? "<li class=" + item.key + ">" + item.value + "</li>" : false);
                                })
                            );
                            btnclick();
                            fancyclose();
                        }
                        return;
                    }
                    btnclick();
                    fancyclose();
                });

                lightboxBtnCancel.on('click', function (e) {
                    e.preventDefault();
                    fancyclose();
                });
            },
            afterClose: function () {
                jQuery('.generic-form.popup-form input').not(':input[type=hidden]').val('');
                jQuery('.generic-form.popup-form .form-group').removeClass('input-error');
            }
        });
    }
}

function initProfUpgrade() {
    var upgradeOpener = jQuery('.upgrade-opener');

    upgradeOpener.unbind('click').on('click', function (e) {
        var self = jQuery(this);
        e.preventDefault();
        fancyboxOpen(self);
        jQuery('.generic-form.popup-form .form-group').removeClass('input-error');
        jQuery('.generic-form.popup-form .form-control').removeClass('field-validation-error');
        jQuery('.generic-form.popup-form .error-text').removeClass('field-validation-error');
        jcf.refreshAll();
    });

    function fancyboxOpen(self) {
        $.fancybox({
            type: 'inline',
            openEffect: 'fade',
            closeEffect: 'fade',
            openSpeed: 'fast',
            wrapCSS: 'upgrade-lightbox',
            height: 'auto',
            beforeShow: function () {
                jQuery('.fancybox-overlay').addClass('upgrade-fancybox');
            },
            beforeLoad: function () {
                this.content = jQuery('.generic-form.popup-form.upgrade-form');
                jQuery('.generic-form.popup-form .form-group').removeClass('input-error');
                
                jcf.refreshAll();
            },
            afterLoad: function (instance, current) {
                var inputList = [];
                var lightboxInputList = [];
                var element = instance.content;
                var formLightBoxFormGroup = element.find('.form-group.check-error');

                function setFormData(holder) {
                    var inputs = holder.find('li');
                    for (var i = 0; i < inputs.length; i++) {
                        var key = inputs.eq(i).attr('class');
                        var value = inputs.eq(i).text();
                        inputList.push({
                            key: key,
                            value: value
                        });
                    }

                    inputList.map(function (item) {
                        var lightboxInput = element.find("#" + item.key);
                        var id = lightboxInput.attr('id');

                        if (item.key == id) {
                            lightboxInput.val(item.value);
                        }
                    });
                }

                if (self.hasClass('btn-edit')) {
                    var holder = self.closest('.holder');
                    setFormData(holder)
                }

                formLightBoxFormGroup.find('input').not(':input[type=button], :input[type=submit], :input[type=reset]').focus(function () {
                    if (jQuery(this).val() != '' && jQuery(this).data('required')) {
                        jQuery(this).closest('.form-group').removeClass('input-error');
                    }
                }).blur(function () {
                    if (jQuery(this).val() == '' && jQuery(this).data('required')) {
                        jQuery(this).closest('.form-group').addClass('input-error');
                    }
                });

                var lightboxBtnSave = instance.content.find('.btn-save');
                var lightboxBtnCancel = instance.content.find('.btn-cancel');
                var thankYouText = instance.content.find('.thank-you-text');

                function fancyclose() {
                    instance.content.find('.form-control').val('');
                    $.fancybox.close(true);
                }

                lightboxBtnSave.unbind('click').on('click', function (e) {
                    e.preventDefault();

                    function renderToDom() {
                        var lightboxInput = element.find('.form-group');
                        for (var i = 0; i < lightboxInput.length; i++) {
                            var key = lightboxInput.eq(i).find('input').attr('id');
                            var value = lightboxInput.eq(i).find('input').val();
                            lightboxInputList.push({
                                key: key,
                                value: value
                            });
                        }
                    }
                    renderToDom();

                    function checkInputError() {
                        var inputControl = formLightBoxFormGroup.find('.form-control');

                        inputControl.each(function () {
                            var $this = jQuery(this);

                            if ($this.val() == '') {
                                $this.closest('.form-group').addClass('input-error');
                            } else {
                                $this.closest('.form-group').removeClass('input-error');
                            }
                        });

                        inputControl.focus(function () {
                            if (jQuery(this).val != '') {
                                jQuery(this).closest('.form-group').removeClass('input-error');
                            }
                        }).blur(function () {
                            if (jQuery(this).val = '') {
                                jQuery(this).closest('.form-group').addClass('input-error');
                            }
                        });
                    }

                    if (self.hasClass('upgrade-opener')) {
                        checkInputError();
                        var isChecked = formLightBoxFormGroup.hasClass('input-error');
                        if (!isChecked) {
                            jQuery(this).siblings('input[type="submit"]').trigger('click');

                            var container = $('.professional');
                            container.removeClass('yellow-style').addClass('no-border-style');
                            container.append('<div class="status">' +
                                '<div class="ico">' +
                                    '<img src="/images/ico-profile.png" srcset="/images/ico-profile@2x.png 2x" alt="ico states" width="47" height="48">' +
                                '</div>' +
                                '<div class="text">Registration Pending</div>' +
                                '</div>');
                            container.find('.btn-holder').remove();
                            
                            instance.content.find('.form-holder').hide();
                            instance.content.find('.btn-list').hide();

                            if (thankYouText.length == 0) {
                                instance.content.append(container.find('.thank-you-text')[0].innerHTML);
                            } else {
                                thankYouText.show();
                            }

                            self.removeClass('upgrade-opener');
                            upgradeOpener.unbind('click');
                        }
                        return;

                    }
                    
                    fancyclose();
                });

                lightboxBtnCancel.on('click', function (e) {
                    e.preventDefault();
                    fancyclose();
                });
            },
            afterClose: function () {
                jQuery('.generic-form.popup-form input').not(':input[type=hidden]').val('');
                jQuery('.generic-form.popup-form .form-group').removeClass('input-error');
            }
        });
    }
}

// content tabs init
function initTabs() {
    jQuery('.tabset').tabset({
        tabLinks: 'a',
        defaultTab: true
    }).each(function () {
        var self = jQuery(this);
        self.find('.drop a').on('click', function () {
            jQuery('.papa-tabset').removeClass('tab-active');
        });

        self.on('click', function () {
            var tabName = $(self).find('a.active h2')[0].innerText;
            dataLayer.push({ event: "tab-view", "tab-name": tabName });
        });
    });

    $('a[href="#profile"]').on('click', function () {
        $('a[href="#tab1-0"]').trigger('click');
        document.location.hash = "profile";
    });

    $('a[href="#details"]').on('click', function () {
        $('a[href="#tab2-0"]').trigger('click');
        document.location.hash = "details";
    });

    $('a[href="#prof"]').on('click', function () {
        $('a[href="#tab2-0"]').trigger('click');
        var topOffset = $('[name="professional"]').position().top;
        jQuery('html, body').animate({ scrollTop: topOffset }, '300');
        $('[name="professional"]').find('.btn-save').trigger('click');
        $('[name="fromProfileTab"]').val('1');
    });

    $('a[href="#prefs"]').on('click', function () {
        $('a[href="#tab3-0"]').trigger('click');
        document.location.hash = "prefs";
    });

    $('a[href="#courses"]').on('click', function () {
        $('a[href="#tab4-0"]').trigger('click');
        document.location.hash = "courses";
    });

    $('a[href="#tab1-0"]').on('click', function () {
        document.location.hash = "profile";
    });

    $('a[href="#tab2-0"]').on('click', function () {
        document.location.hash = "details";
    });

    $('a[href="#tab3-0"]').on('click', function () {
        document.location.hash = "prefs";
    });

    $('a[href="#tab4-0"]').on('click', function () {
        document.location.hash = "courses";
    });

    if (document.location.hash) {
        switch (document.location.hash.replace("#", "")) {
            case "profile":
                $('a[href="#tab1-0"]').trigger('click');
                break;
            case "details":
                $('a[href="#tab2-0"]').trigger('click');
                break;
            case "prefs":
                $('a[href="#tab3-0"]').trigger('click');
                break;
            case "courses":
                $('a[href="#tab4-0"]').trigger('click');
                break;
            default:
                $('a[href="#tab1-0"]').trigger('click');
                break;
        }
    }

    var queryString = getUrlVars();
    if (queryString["tab"]) {
        switch (queryString["tab"]) {
            case "profile":
                $('a[href="#tab1-0"]').trigger('click');
                break;
            case "details":
                $('a[href="#tab2-0"]').trigger('click');
                break;
            case "prefs":
                $('a[href="#tab3-0"]').trigger('click');
                break;
            case "courses":
                $('a[href="#tab4-0"]').trigger('click');
                break;
        }
    }

    document.getElementsByTagName("BODY")[0].onhashchange = function () {
        switch (document.location.hash.replace("#", "")) {
            case "profile":
                $('a[href="#tab1-0"]').trigger('click');
                break;
            case "details":
                $('a[href="#tab2-0"]').trigger('click');
                break;
            case "prefs":
                $('a[href="#tab3-0"]').trigger('click');
                break;
            case "courses":
                $('a[href="#tab4-0"]').trigger('click');
                break;
            default:
                $('a[href="#tab1-0"]').trigger('click');
                break;
        }
    };

    if (queryString["panel"]) {
        switch (queryString["panel"]) {
            case "addaddress":
                var topOffset = $('[name="addresses"]').position().top;
                jQuery('html, body').animate({ scrollTop: topOffset }, '300', function () {
                    jQuery('.address-opener').trigger('click');
                });
                break;
            default:
                var topOffset = $('[name="' + queryString["panel"] + '"]').position().top;
                jQuery('html, body').animate({ scrollTop: topOffset }, '300', function () {
                    setTimeout(function () {
                        //('[name="' + queryString["panel"] + '"]').find('.btn-save').trigger('click');
                    }, 500);
                });
                break;
        }
    }

    function getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }
}

function initScrollTop() {
    if ($(window).scrollTop() > 100) {
        $('#scrollToTop').fadeIn();
    }
    else {
        $('#scrollToTop').fadeOut();
    }

    $(window).scroll(scrollEvent);
    $(window).resize(scrollEvent);

    $("a#scrollToTop").click(function () {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
    });
}

function scrollEvent(e) {
    e.preventDefault();
    if ($(window).scrollTop() > 100) {
        $('#scrollToTop').fadeIn();
    }
    else {
        $('#scrollToTop').fadeOut();
    }
}

// populate "I would like" dropdown
function initHelpForm() { 
    $('.finder-form').trigger('reset');
    $('#IAmA').change(function () {
        $.ajax({
            url: '/Umbraco/Api/HelpFormApi/IWouldLike?iAmA=' + $(this).val(),
            error: function (jqXHR, textStatus, errorThrown) {
            },
            success: function (result, textStatus, jqXHR) {
                var options = '';
                if (result.data.length <= 0) options = '<option value="">Select an "I am..." option</option>';
                else options = '<option value="">I\'d like...</option>';
                for (var i = 0; i < result.data.length; i++) {
                    var text = result.data[i].title;

                    options += '<option value="' + text + '">' + text + '</option>';
                }

                $('#IWouldLike').html(options);
                $('#IWouldLike').val = '';
                jcf.refreshAll();
            },
            complete: function (jqXHR, textStatus) {
            },
            dataType: 'json'
        });
    });
    $('.finder-btn').click(function (e) {
        var iAmA = $('#IAmA').find('option:selected').text();
        var idLikeTo = $('#IWouldLike').find('option:selected').text();
        dataLayer.push({ event: "header-finder-search", "header-finder-i-am-a": iAmA, "header-finder-id-like-to": idLikeTo });
    });
}

function initBlogReplyForm() {
    var $forms = $('form.post-form');
    $forms.each(function () {
        var $form = $(this);
        $form.removeData("validator");
        $form.removeData("unobtrusiveValidation");
        $.validator.unobtrusive.parse($form);
    });
}

function initRecaptchaChange() {
    $('#g-recaptcha-response').on("change keyup paste", function () {
        $('#recaptchaResponse').val($(this).val());
    });
}

function initStoryFormText() {
    if (jQuery.browser.mobile) {
        $('#storyFormMobile').show();
        $('#storyFormDesktop').hide();
    } else {
        $('#storyFormMobile').hide();
        $('#storyFormDesktop').show();
    }
}

var droppedFiles = new Array();
// change displays of file uploads when files are selected
function initFileInputs() {
    var inputs = jQuery('.inputfile');
    Array.prototype.forEach.call(inputs, function (input) {
        var label = input.nextElementSibling,
            labelVal = label.innerHTML;
        jQuery('#' + $(label).data('textfield'))[0].style.display = 'none';

        input.addEventListener('change', function (e) {
            var fileName = '';
            if (this.files && this.files.length > 1)
                fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
            else
                fileName = e.target.value.split('\\').pop();

            if (fileName) {
                jQuery('#' + $(label).data('textfield'))[0].innerHTML = fileName;
                jQuery('#' + $(label).data('textfield'))[0].style.display = 'block';
            } else {
                jQuery('#' + $(label).data('textfield'))[0].style.display = 'none';
            }

            for (var i = 0, l = this.files.length; i < l; i++) {
                droppedFiles.push(this.files[i]);
            }
            showFiles(droppedFiles, $('#files'), $('#inputtext'));
        });
    });
}

function initStoryFormDragDrop() {
    var $form = $('#storyForm'),
        $input = $form.find('#files'),
        $label = $form.find('#filesLabel'),
        $button = $form.find('#submit'),
        $errorMsg = $form.find('#storyFormUpdate'),
        $fileText = $form.find('#inputtext');

    var isAdvancedUpload = function () {
        var label = $('label[for="files"]');
        return (('draggable' in label) || ('ondragstart' in label && 'ondrop' in label)) && 'FormData' in window && 'FileReader' in window;
    };

    // letting the server side to know we are going to make an Ajax request
    $form.append('<input type="hidden" name="ajax" value="1" />');

    // drag&drop files if the feature is available
    if (isAdvancedUpload) {
        $label
            .addClass('has-advanced-upload') // letting the CSS part to know drag&drop is supported by the browser
            .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
                // preventing the unwanted behaviours
                e.preventDefault();
                e.stopPropagation();
            })
            .on('dragover dragenter', function () //
            {
                $form.addClass('is-dragover');
                $label[0].style.borderColor = '#000';
            })
            .on('dragleave dragend drop', function () {
                $form.removeClass('is-dragover');
                $label[0].style.borderColor = '';
            })
            .on('drop', function (e) {
                var files = e.originalEvent.dataTransfer.files;
                for (var i = 0, l = files.length; i < l; i++) {
                    var mimeType = files[i]['type'];
                    var ext = files[i]['name'].split('.').pop().toLowerCase();
                    if (mimeType.split('/')[0] === 'image' || $.inArray(ext, ['pdf', 'docx', 'doc', 'txt']) > -1) {
                        droppedFiles.push(files[i]);
                    } else {
                        alert(files[i]['name'] + ': Incorrect file format. Please try another file.');
                    }
                }
                showFiles(droppedFiles, $input, $fileText);
            });
    }

    // if the form was submitted

    $button.on('click', function (e) {
        // preventing the duplicate submissions if the current one is in progress
        if ($form.hasClass('is-uploading')) return false;

        $form.addClass('is-uploading').removeClass('is-error');

        if (isAdvancedUpload) // ajax file upload for modern browsers
        {
            e.preventDefault();

            $(this).text('Sending... ');

            // gathering the form data
            var ajaxData = new FormData($form.get(0));
            if (droppedFiles) {
                $.each(droppedFiles, function (i, file) {
                    ajaxData.append($input.attr('name'), file);
                });
            }

            // ajax request
            $.ajax(
                {
                    url: $form.attr('action'),
                    type: $form.attr('method'),
                    data: ajaxData,
                    dataType: 'json',
                    cache: false,
                    contentType: false,
                    processData: false,
                    complete: function () {
                        $form.removeClass('is-uploading');
                    },
                    success: function (data) {
                        if (data) {
                            $form.addClass(data.success == true ? 'is-success' : 'is-error');
                            if (data.success) {
                                $errorMsg.text(data.message);
                            } else {
                                $errorMsg.text(data.error);
                            }
                        }
                    },
                    error: function () {
                        alert('Error. Please, contact the webmaster!');
                    }
                });

            $(this).text('Send ');
        }
        else // fallback Ajax solution upload for older browsers
        {
            var iframeName = 'uploadiframe' + new Date().getTime(),
                $iframe = $('<iframe name="' + iframeName + '" style="display: none;"></iframe>');

            $('body').append($iframe);
            $form.attr('target', iframeName);

            $iframe.one('load', function () {
                var data = $.parseJSON($iframe.contents().find('body').text());
                $form.removeClass('is-uploading').addClass(data.success == true ? 'is-success' : 'is-error').removeAttr('target');
                if (!data.success) $errorMsg.text(data.error);
                $iframe.remove();
            });
        }
    });
}

function showFiles (files, $input, $fileText) {
    $fileText.text(files.length > 1 ? ($input.attr('data-multiple-caption') || '').replace('{count}', files.length) : files[0].name);
    if (files.length > 0) {
        $fileText.show();
    } else {
        $fileText.text('');
        $fileText.hide();
    }
}

function initShareLinks() {
    $('.share-btn').click(function () {
        window.open($(this).attr('href'), 'Share this page', 'width=540,height=450');
        return false;
    });
}

function initFormValidation() {
    jQuery('.form-validation').formValidation({
        errorClass: 'input-error',
        addClassToParent: '.check-error'
    });

    //calculate the offset for the errors
    var formHolder = jQuery('.form-validation');
    formHolder.each(function () {
        var self = jQuery(this);

        self.on('submit', function () {
            if (jQuery(document.activeElement).siblings('input[type="submit"]').attr('formnovalidate') == undefined) {
                var errorBlocks = self.find('.check-error');
                var isErrorOccured = errorBlocks.hasClass('input-error');

                if (isErrorOccured) {
                    errorBlocks = self.find('.check-error.input-error');
                    var max = jQuery('body').height(), $element;

                    errorBlocks.each(function () {
                        var $this = jQuery(this);

                        if ($this.offset().top < max) {
                            max = $this.offset().top;
                            $element = $this;
                        }
                    });

                    var topOffset = $element.offset().top - 15;
                    jQuery('html, body').animate({ scrollTop: topOffset }, '300');
                }
            } else {
                self.submit();
            }
        });
    });
}

// popups init
function initPopups() {
    jQuery('.popup-holder').contentPopup({
        mode: 'click',
        btnOpen: '.link-tooltip'
    });
}

//initShowFilter
function initShowFilter() {
    var holder = jQuery('.aside-filter-holder');
    holder.each(function () {
        var filterHolder = jQuery(this);
        var filterArea = filterHolder.find('.filter-lists');
        var count = filterArea.children().length;
        var linkShow = filterHolder.find('.link-show');
        var activeClass = 'filter-active';

        if (count >= 6) {
            linkShow.show();
        }

        linkShow.on('click', function (e) {
            e.preventDefault();
            filterHolder.toggleClass(activeClass);
        });
    });
}

function initMenuDrop() {
    jQuery('.menu-drop > ul').each(function () {
        var menu = jQuery(this);

        ResponsiveHelper.addRange({
            '768': {
                on: function () {
                    if (!menu.data('MenuDrop')) {
                        menu.menuDrop({
                            activeClass: 'hover',
                            dropHolder: '.has-drop-down',
                            drop: '> .nav-drop'
                        });
                    }
                }
            },
            '..767': {
                on: function () {
                    if (menu.data('MenuDrop')) {
                        menu.data('MenuDrop').destroy();
                    }
                }
            }
        })
    })
}

//indent fix for images and text
function initIndentFix() {
    ; (function () {
        document.addEventListener('lazyloaded', function (e) {
            var img = e.target;
            var classname = 'bg-wrap';
            var bgParent = closest(e.target, classname);

            if (bgParent !== null) {
                var imgSrc = img.currentSrc ? img.currentSrc : img.src;
                img.style.visibility = 'hidden';
                bgParent.style.backgroundImage = 'url(' + imgSrc + ')';
                bgParent.style.backgroundSize = 'cover';
                bgParent.style.backgroundRepeat = 'no-repeat';
                bgParent.style.backgroundPosition = '50% 50%';
            }
        });
        function closest(e, classname) {
            if (hasClass(e, classname)) {
                //found
                return e;
            }
            //console.error(e.parentNode.nodeName);
            if (e.parentNode.nodeName != 'BODY') //Last possibility! There's no parent behind!
                return e.parentNode && closest(e.parentNode, classname);

            //not found
            return null;
        }

        var hasClass;
        if ('classList' in document.documentElement) {
            hasClass = function (elem, c) {
                return elem.classList.contains(c);
            };
        }
        else {
            hasClass = function (elem, c) {
                return classReg(c).test(elem.className);
            };
        }
    })();
}

// init retina cover
function initRetinaCover() {
    jQuery('.bg-stretch').retinaCover();
}

// &quot;tab&quot; key handling
function initTabNav() {
    jQuery('#nav').tabNav({
        items: 'li'
    });
}

// initialize smooth anchor links
function initAnchors() {
    new SmoothScroll({
        anchorLinks: '.filter-accordion .btn-top',
        extraOffset: 0,
        wheelBehavior: 'none'
    });

    new SmoothScroll({
        anchorLinks: '.link-area .link-scroll',
        extraOffset: 0,
        wheelBehavior: 'none'
    });
}

// accordion menu init
function initAccordion() {
    jQuery('.filter-accordion').slideAccordion({
        opener: '.opener, .btn-close',
        slider: '.slide',
        animSpeed: 300
    });
}

// lightbox init
function initFancybox() {
    var loadingTimer;
    var loadingDelay = 1000;

    jQuery('a.lightbox, a[rel*="lightbox"]').fancybox({
        helpers: {
            overlay: {
                css: {
                    background: 'rgba(0, 0, 0, 0.8)'
                }
            }
        },
        nextEffect: 'fade',
        prevEffect: 'fade',
        fitToView: 'true',
        autoSize: 'true',
        beforeShow: function () {
            jQuery('.fancybox-wrap').addClass('fancybox-loading');
        },
        beforeLoad: function () {
            jQuery('.fancybox-wrap').addClass('fancybox-loading');
        },
        afterShow: function () {
            clearTimeout(loadingTimer);
            loadingTimer = setTimeout(function () {
                jQuery('.fancybox-wrap').removeClass('fancybox-loading');
            }, loadingDelay);

        },
        afterLoad: function (current, previous) {
            // handle custom close button in inline modal
            if (current.href.indexOf('#') === 0) {
                jQuery(current.href).find('a.close').off('click.fb').on('click.fb', function (e) {
                    e.preventDefault();
                    jQuery.fancybox.close();
                });
            }

            if (current.group.length && current.group.length > 1) {
                jQuery('.fancybox-wrap').addClass('fancy-gallery');
            }

            if ($(this.element).attr('title') != undefined && $(this.element).attr('title').length > 0) {
                this.inner.prepend('<h2 class="title">' + $(this.element).attr('title') + '</h2>');
                this.skin.addClass('with-title');
            }

            if ($(this.element).data('description') != undefined) {
                this.title = '<p class="child">' + $(this.element).data('description') + '</p>';
            }

            // if youtube url then post GA event
            if (current.href.indexOf('youtube') > 0) {
                dataLayer.push({ event: "youtube-video-play", "youtube-video-url": current.href });
            }
        },
        iframe: {
            preload: true
        },
        image: {
            preload: false
        }
    });
}

// load more init
function initLoadMore() {
    jQuery('.load-more-holder').loadMore({
        linkSelector: 'a.load-more',
        newContentTarget: '.load-more-results'
    }).on('ContentLoader/loading', function () {
        $('a.load-more').html('<img src="/images/loading.gif" alt="Loading More" width="17" />');
    }).on('ContentLoader/loaded', function () {
        initRetinaCover();
        initFancybox();
        $('a.load-more').html('Show More');
    });
}

// slick init
function initSlickCarousel() {
    jQuery('.carousel-block .text-slider').slick({
        slidesToScroll: 1,
        rows: 0,
        prevArrow: '<button class="slick-prev"><span class="icon-chevron-left"></span><span class="hidden">Previous</span></button>',
        nextArrow: '<button class="slick-next"><span class="icon-chevron-right"></span><span class="hidden">Next</span></button>',
        pauseOnDotsHover: false,
        infinite: true,
        fade: true,
        adaptiveHeight: false,
        asNavFor: '.carousel-block .visual-slider',
        autoplay: true,
        autoplaySpeed: 12000,
        dots: true
    }).each(function () {
        var $this = jQuery(this);
        $this.append('<button class="slick-playpause"><span class="icon-play"></span><span class="icon-pause"></span><span class="hidden">Pause</span></button>');
        var playpauseBtn = $this.find('.slick-playpause');

        playpauseBtn.on('click', function (e) {
            e.preventDefault();
            playpauseBtn.toggleClass('paused');
            var pauseState = $this.find('.slick-playpause').hasClass('paused');

            if (pauseState) {
                $this.slick('slickPause');
            }
            else {
                $this.slick('slickPlay');
            }
        });
        });

    jQuery('.carousel-block .visual-slider').slick({
        slidesToScroll: 1,
        rows: 0,
        arrows: false,
        asNavFor: '.carousel-block .text-slider',
        autoplay: false,
        autoplaySpeed: 12000,
        dots: false
    });

    jQuery('.events-slider').slick({
        slidesToScroll: 1,
        rows: 0,
        prevArrow: '<a href="#" class="slick-prev"><span class="icon-chevron-left"></span><span class="hidden">Previous</span></a>',
        nextArrow: '<a href="#" class="slick-next"><span class="icon-chevron-right"></span><span class="hidden">Next</span></a>',
        autoplay: false,
        mobileFirst: true,
        centerMode: true,
        centerPadding: '21px',
        // 991
        responsive: [
            {
                breakpoint: 749,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    centerPadding: '0px',
                    dots: false,
                    centerMode: false
                }
            }/*,
    {
			breakpoint: 991,
			settings: "unslick"
		}*/
        ]
    }).each(function () {
        var self = jQuery(this);

        jQuery(window).on('resize orientationchange', function () {
            self.slick('resize');
        });
    });
}

// mobile menu init
function initMobileNav() {
    jQuery('body').mobileNav({
        menuActiveClass: 'nav-active',
        menuOpener: '.nav-opener',
        hideOnClickOutside: true,
        menuDrop: '.menu-drop, .shoping-card-block'
    }).each(function () {
        var shopCard = jQuery('#headerBasket');
        var titleHead = shopCard.find('.title-head');
        titleHead.append('<a href="#" class="shop-card-close normal"><span class="icon-close"></span></a>');

        var shopCardAdd = jQuery('#headerBasketAdd');
        var titleHeadAdd = shopCardAdd.find('.title-head');
        titleHeadAdd.append('<a href="#" class="shop-card-close added"><span class="icon-close"></span></a>');
    });
    jQuery('body').mobileNav({
        menuActiveClass: 'search-active',
        menuOpener: '#header .search-opener',
        hideOnClickOutside: true,
        menuDrop: '.search-block'
    });
    jQuery('body').mobileNav({
        menuActiveClass: 'header-form-active',
        menuOpener: '#header .finder-opener',
        hideOnClickOutside: true,
        menuDrop: '.finder-form'
    });
    jQuery('body').mobileNav({
        menuActiveClass: 'signIn-active',
        menuOpener: '#header .is-loggedin .signin-opener',
        hideOnClickOutside: true,
        menuDrop: '.signin-block ul'
    });
    jQuery('body').mobileNav({
        menuActiveClass: 'cart-active basket',
        menuOpener: '#header .info-nav .d-xs-none a.basket-opener, .link-basket a, .shop-card-close.normal',
        hideOnClickOutside: true,
        menuDrop: '#headerBasket'
    });
    jQuery('body').mobileNav({
        menuActiveClass: 'cart-active add',
        menuOpener: 'a.can-add, .shop-card-close.added',
        hideOnClickOutside: true,
        menuDrop: '#headerBasketAdd',
        actionOnOpen: 'show'
    });
    jQuery('.filter-area').mobileNav({
        menuActiveClass: 'a2z-active',
        menuOpener: '.filter-opener-a2z',
        hideOnClickOutside: true,
        menuDrop: '.filter-drop'
    });
    jQuery('.filter-area').mobileNav({
        menuActiveClass: 'cat-active',
        menuOpener: '.filter-opener-cat',
        hideOnClickOutside: true,
        menuDrop: '.filter-drop'
    });
    jQuery('.share-block').mobileNav({
        menuActiveClass: 'share-active',
        menuOpener: '.share-opener, .share-list .close',
        hideOnClickOutside: true,
        menuDrop: '.share-list'
    });
    jQuery('body').mobileNav({
        menuActiveClass: 'topic-active',
        menuOpener: '.topic-opener, .topic-opener .close',
        hideOnClickOutside: true,
        menuDrop: '.share-list'
    });
    jQuery('body').mobileNav({
        menuActiveClass: 'author-active',
        menuOpener: '.author-opener, .author-opener .close',
        hideOnClickOutside: true,
        menuDrop: '.share-list'
    });
    jQuery('body').mobileNav({
        menuActiveClass: 'archive-active',
        menuOpener: '.archive-opener, .archive-opener .close',
        hideOnClickOutside: true,
        menuDrop: '.share-list'
    });
    jQuery('.papa-tabset').mobileNav({
        menuActiveClass: 'tab-active',
        menuOpener: '.tab-opener',
        hideOnClickOutside: true,
        menuDrop: '.drop ul'
    });
    jQuery('body').mobileNav({
        menuActiveClass: 'kb-search-active',
        menuOpener: '#main .kb-search-opener',
        hideOnClickOutside: true,
        menuDrop: '.keyword_search-form'
    });
}

// add classes if item has dropdown
function initDropDownClasses() {
    jQuery('.menu-drop li').each(function () {
        var item = jQuery(this);
        var innerHolder = item.find('.nav-drop').eq(0);
        var drop = item.find('ul');
        var link = item.find('a').eq(0);
        var linkHeading = link.text();
        if (drop.length) {
            item.addClass('has-drop-down');
            if (link.length) link.addClass('has-drop-down-a').append('<span class="opener-holder"><span class="sub-level-opener icon-angle-right"></span></span>');

            if (item.hasClass('has-drop-down')) {
                innerHolder.prepend('<strong class="top-link"><a href="#" class="link-back">Back</a><span class="link-Heading">' + linkHeading + '</span></strong>');
            }

            link.on('touchstart', function (e) {
                if (item.parent().parent('.nav-drop').length == 0) {
                    ResponsiveHelper.addRange({
                        '750': {
                            on: function () {
                                e.stopImmediatePropagation();
                                e.stopPropagation();
                                if (item.hasClass('hover')) {
                                    return true;
                                } else {
                                    $('.menu-drop li.has-drop-down.hover').each(function () {
                                        $(this).removeClass('hover');
                                    });
                                    item.addClass('hover');
                                    item.css('text-decoration', 'underline');
                                    e.preventDefault();
                                    return false;
                                }
                            }
                        }
                    });
                }
            });
        }
    });

    $('html').on('touchstart', function (e) {
        $('.menu-drop li.has-drop-down.hover').each(function () {
            ResponsiveHelper.addRange({
                '750': {
                    on: function () {
                        $(this).removeClass('hover');
                    }
                }
            });
        });
    });
}

// initialize custom form elements
function initCustomForms() {
    jcf.setOptions('Select', {
        wrapNative: false,
        wrapNativeOnMobile: false
    });
    jcf.replaceAll();
}

/*
 * jQuery Tabs plugin
 */

; (function ($, $win) {
    'use strict';

    function Tabset($holder, options) {
        this.$holder = $holder;
        this.options = options;

        this.init();
    }

    Tabset.prototype = {
        init: function () {
            this.$tabLinks = this.$holder.find(this.options.tabLinks);

            this.setStartActiveIndex();
            this.setActiveTab();

            if (this.options.autoHeight) {
                this.$tabHolder = $(this.$tabLinks.eq(0).attr(this.options.attrib)).parent();
            }

            this.makeCallback('onInit', this);
        },

        setStartActiveIndex: function () {
            var $classTargets = this.getClassTarget(this.$tabLinks);
            var $activeLink = $classTargets.filter('.' + this.options.activeClass);
            var $hashLink = this.$tabLinks.filter('[' + this.options.attrib + '="' + location.hash + '"]');
            var activeIndex;

            if (this.options.checkHash && $hashLink.length) {
                $activeLink = $hashLink;
            }

            activeIndex = $classTargets.index($activeLink);

            this.activeTabIndex = this.prevTabIndex = (activeIndex === -1 ? (this.options.defaultTab ? 0 : null) : activeIndex);
        },

        setActiveTab: function () {
            var self = this;

            this.$tabLinks.each(function (i, link) {
                var $link = $(link);
                var $classTarget = self.getClassTarget($link);
                var $tab = $($link.attr(self.options.attrib));

                if (i !== self.activeTabIndex) {
                    $classTarget.removeClass(self.options.activeClass);
                    $tab.addClass(self.options.tabHiddenClass).removeClass(self.options.activeClass);
                } else {
                    $classTarget.addClass(self.options.activeClass);
                    $tab.removeClass(self.options.tabHiddenClass).addClass(self.options.activeClass);
                }

                self.attachTabLink($link, i);
            });
        },

        attachTabLink: function ($link, i) {
            var self = this;

            $link.on(this.options.event + '.tabset', function (e) {
                e.preventDefault();

                if (self.activeTabIndex === self.prevTabIndex && self.activeTabIndex !== i) {
                    self.activeTabIndex = i;
                    self.switchTabs();
                }
                if (self.options.checkHash) {
                    location.hash = jQuery(this).attr('href').split('#')[1]
                }
            });
        },

        resizeHolder: function (height) {
            var self = this;

            if (height) {
                this.$tabHolder.height(height);
                setTimeout(function () {
                    self.$tabHolder.addClass('transition');
                }, 10);
            } else {
                self.$tabHolder.removeClass('transition').height('');
            }
        },

        switchTabs: function () {
            var self = this;

            var $prevLink = this.$tabLinks.eq(this.prevTabIndex);
            var $nextLink = this.$tabLinks.eq(this.activeTabIndex);

            var $prevTab = this.getTab($prevLink);
            var $nextTab = this.getTab($nextLink);

            $prevTab.removeClass(this.options.activeClass);

            if (self.haveTabHolder()) {
                this.resizeHolder($prevTab.outerHeight());
            }

            setTimeout(function () {
                self.getClassTarget($prevLink).removeClass(self.options.activeClass);

                $prevTab.addClass(self.options.tabHiddenClass);
                $nextTab.removeClass(self.options.tabHiddenClass).addClass(self.options.activeClass);

                self.getClassTarget($nextLink).addClass(self.options.activeClass);

                if (self.haveTabHolder()) {
                    self.resizeHolder($nextTab.outerHeight());

                    setTimeout(function () {
                        self.resizeHolder();
                        self.prevTabIndex = self.activeTabIndex;
                        self.makeCallback('onChange', self);
                    }, self.options.animSpeed);
                } else {
                    self.prevTabIndex = self.activeTabIndex;
                }
            }, this.options.autoHeight ? this.options.animSpeed : 1);
        },

        getClassTarget: function ($link) {
            return this.options.addToParent ? $link.parent() : $link;
        },

        getActiveTab: function () {
            return this.getTab(this.$tabLinks.eq(this.activeTabIndex));
        },

        getTab: function ($link) {
            return $($link.attr(this.options.attrib));
        },

        haveTabHolder: function () {
            return this.$tabHolder && this.$tabHolder.length;
        },

        destroy: function () {
            var self = this;

            this.$tabLinks.off('.tabset').each(function () {
                var $link = $(this);

                self.getClassTarget($link).removeClass(self.options.activeClass);
                $($link.attr(self.options.attrib)).removeClass(self.options.activeClass + ' ' + self.options.tabHiddenClass);
            });

            this.$holder.removeData('Tabset');
        },

        makeCallback: function (name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        }
    };

    $.fn.tabset = function (opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        var options = $.extend({
            activeClass: 'active',
            addToParent: false,
            autoHeight: false,
            checkHash: false,
            defaultTab: true,
            animSpeed: 500,
            tabLinks: 'a',
            attrib: 'href',
            event: 'click',
            tabHiddenClass: 'js-tab-hidden'
        }, opt);
        options.autoHeight = options.autoHeight;

        return this.each(function () {
            var $holder = jQuery(this);
            var instance = $holder.data('Tabset');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                $holder.data('Tabset', new Tabset($holder, options));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    };
}(jQuery, jQuery(window)));

/*
 * Accessible TAB navigation
 */
; (function ($) {
    var isWindowsPhone = /Windows Phone/.test(navigator.userAgent);
    var isTouchDevice = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;

    $.fn.tabNav = function (opt) {
        var options = $.extend({
            hoverClass: 'hover',
            items: 'li',
            opener: '>a',
            delay: 10
        }, opt);

        if (isWindowsPhone || isTouchDevice) {
            return this;
        }

        return this.each(function () {
            var nav = $(this), items = nav.find(options.items);

            items.each(function (index, navItem) {
                var item = $(this), navActive, touchNavActive;
                var link = item.find(options.opener), timer;

                link.bind('focus', function () {
                    navActive = nav.hasClass('js-nav-active');
                    touchNavActive = window.TouchNav && TouchNav.isActiveOn(navItem);
                    if (!navActive || touchNavActive) {
                        initSimpleNav();
                    }
                    item.trigger(navActive && touchNavActive ? 'itemhover' : 'mouseenter');
                }).bind('blur', function () {
                    item.trigger(navActive && touchNavActive ? 'itemleave' : 'mouseleave');
                });

                var initSimpleNav = function () {
                    if (!initSimpleNav.done) {
                        initSimpleNav.done = true;
                        item.hover(function () {
                            clearTimeout(timer);
                            timer = setTimeout(function () {
                                item.addClass(options.hoverClass);
                            }, options.delay);
                        }, function () {
                            clearTimeout(timer);
                            timer = setTimeout(function () {
                                item.removeClass(options.hoverClass);
                            }, options.delay);
                        });
                    }
                };
            });
        });
    };
}(jQuery));

// mobile menu
function initMenuLayout() {
    var nav = jQuery('#nav');
    var timer;

    // handle layout resize
    ResponsiveHelper.addRange({
        '..749': {
            on: function () {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    nav.slideMenu({
                        item: '.has-drop-down',
                        opener: '.sub-level-opener',
                        slide: '.nav-drop',
                        btnBack: '.link-back',
                        menuWrapper: '.menu-drop',
                        difNum: 0,
                        gapNum: 0,
                        animSpeed: 300
                    });
                }, 100);
            },
            off: function () {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    if (nav.data('SlideMenu') !== undefined) {
                        nav.data('SlideMenu').destroy();
                    }
                }, 100);
            }
        }
    });
}

/**
 * jQuery.browser.mobile (http://detectmobilebrowser.com/)
 *
 * jQuery.browser.mobile will be true if the browser is a mobile device
 *
 **/
(function (a) { (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)) })(navigator.userAgent || navigator.vendor || window.opera);

/*
 * jQuery form validation plugin
 */
; (function ($) {
    'use strict';

    var FormValidation = (function () {
        var Validator = function ($field, $fields) {
            this.$field = $field;
            this.$fields = $fields;
        };

        Validator.prototype = {
            reg: {
                email: "^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$",
                number: '^[0-9]+$'
            },

            checkField: function () {
                return {
                    state: this.run(),
                    $fields: this.$field.add(this.additionalFields)
                }
            },

            run: function () {
                var fieldType;

                switch (this.$field.get(0).tagName.toUpperCase()) {
                    case 'SELECT':
                        fieldType = 'select';
                        break;

                    case 'TEXTAREA':
                        fieldType = 'text';
                        break;

                    default:
                        fieldType = this.$field.data('type') || this.$field.attr('type');
                }

                var functionName = 'check_' + fieldType.replace(/-/g, '_');
                var state = true;

                if ($.isFunction(this[functionName]) && !this.$field.attr('readonly')) {
                    state = this[functionName]();

                    if (state && this.$field.data('confirm')) {
                        state = this.check_confirm();
                    }
                }

                if (this.$field.closest('form').find('.validate-this-only').length > 0 && !this.$field.closest('.panel-block').hasClass('validate-this-only')) {
                    state = true;
                }

                return state;
            },

            check_email: function () {
                var value = this.getValue();
                var required = this.$field.data('required');
                var requiredOrValue = required || value.length;

                if ((requiredOrValue && !this.check_regexp(value, this.reg.email))) {
                    return false;
                }

                return requiredOrValue ? true : null;
            },

            check_number: function () {
                var value = this.getValue();
                var required = this.$field.data('required');
                var isNumber = this.check_regexp(value, this.reg.number);
                var requiredOrValue = required || value.length;

                if (requiredOrValue && !isNumber) {
                    return false;
                }

                var min = this.$field.data('min');
                var max = this.$field.data('max');
                value = +value;

                if ((min && (value < min || !isNumber)) || (max && (value > max || !isNumber))) {
                    return false;
                }

                return (requiredOrValue || min || max) ? true : null;
            },

            check_password: function () {
                return this.check_text();
            },

            check_text: function () {
                var value = this.getValue();
                var required = this.$field.data('required');

                if (this.$field.data('required') && !value.length) {
                    return false;
                }

                var min = +this.$field.data('min');
                var max = +this.$field.data('max');

                if ((min && value.length < min) || (max && value.length > max)) {
                    return false;
                }

                var regExp = this.$field.data('regexp');

                if (regExp && !this.check_regexp(value, regExp)) {
                    return false;
                }

                var requiredIf = this.$field.data('requiredif');
                var desiredValue = this.$field.data('desiredvalue');
                if (requiredIf) {
                    if ($('input[name="' + requiredIf + '"]:checked').val().toLowerCase() == desiredValue.toString()) {
                        return value.length > 0;
                    }
                }

                return (required || min || max || regExp) ? true : null;
            },

            check_confirm: function () {
                var value = this.getValue();
                var $confirmFields = this.$fields.filter('[data-confirm="' + this.$field.data('confirm') + '"]');
                var confirmState = true;

                for (var i = $confirmFields.length - 1; i >= 0; i--) {
                    if ($confirmFields.eq(i).val() !== value || !value.length) {
                        confirmState = false;
                        break;
                    }
                }

                this.additionalFields = $confirmFields;

                return confirmState;
            },

            check_select: function () {
                var required = this.$field.data('required');

                if (required && this.$field.get(0).selectedIndex === 0) {
                    return false;
                }

                return required ? true : null;
            },

            check_radio: function () {
                var $fields = this.$fields.filter('[name="' + this.$field.attr('name') + '"]');
                var required = this.$field.data('required');

                if (required && !$fields.filter(':checked').length) {
                    return false;
                }

                this.additionalFields = $fields;

                return required ? true : null;
            },

            check_checkbox: function () {
                var required = this.$field.data('required');

                if (required && !this.$field.prop('checked')) {
                    return false;
                }

                return required ? true : null;
            },

            check_at_least_one: function () {
                var $fields = this.$fields.filter('[data-name="' + this.$field.data('name') + '"]');

                if (!$fields.filter(':checked').length) {
                    return false;
                }

                this.additionalFields = $fields;

                return true;
            },

            check_regexp: function (val, exp) {
                return new RegExp(exp).test(val);
            },

            getValue: function () {
                if (this.$field.data('trim')) {
                    this.$field.val($.trim(this.$field.val()));
                }

                return this.$field.val();
            }
        };

        var publicClass = function (form, options) {
            this.$form = $(form).attr('novalidate', 'novalidate');
            this.options = options;
        };

        publicClass.prototype = {
            buildSelector: function (input) {
                return input + ':not(' + this.options.skipDefaultFields + (this.options.skipFields ? ',' + this.options.skipFields : '') + ')';
            },

            init: function () {
                this.fieldsSelector = this.buildSelector(':input');

                this.$form
                    .on('submit', this.submitHandler.bind(this))
                    .on('keyup blur touchleave touchend', this.fieldsSelector, this.changeHandler.bind(this))
                    .on('change', this.buildSelector('input[type="radio"]'), this.changeHandler.bind(this))
                    .on('change', this.buildSelector('select'), this.changeHandler.bind(this))
                    .on('focus', this.fieldsSelector, this.focusHandler.bind(this));
            },

            submitHandler: function (e) {
                var self = this;
                var $fields = this.getFormFields();

                this.getClassTarget($fields)
                    .removeClass(this.options.errorClass + ' ' + this.options.successClass);

                this.setFormState(true);

                if ($(e.currentTarget).find('button:hover').attr('name') != 'Previous') {
                    $fields.each(function (i, input) {
                        var $field = $(input);
                        var $classTarget = self.getClassTarget($field);

                        // continue iteration if $field has error class already
                        if ($classTarget.hasClass(self.options.errorClass)) {
                            return;
                        }

                        self.setState(new Validator($field, $fields).checkField());
                    });
                }

                return this.checkSuccess($fields, e);
            },

            checkSuccess: function ($fields, e) {
                var self = this;
                var success = this.getClassTarget($fields || this.getFormFields())
                    .filter('.' + this.options.errorClass).length === 0;

                if (e && success && this.options.successSendClass) {
                    e.preventDefault();
                    success = true;

                    $.ajax({
                        url: this.$form.removeClass(this.options.successSendClass).attr('action') || '/',
                        type: this.$form.attr('method') || 'POST',
                        data: this.$form.serialize(),
                        success: function () {
                            self.$form.addClass(self.options.successSendClass);
                        }
                    });
                }

                this.setFormState(success);

                return success;
            },

            changeHandler: function (e) {
                var $field = $(e.target);

                var code = e.keyCode || e.which;
                if (code != '9') {
                    if ($field.data('interactive')) {
                        this.setState(new Validator($field, this.getFormFields()).checkField());
                    }
                }

                this.checkSuccess();
            },

            focusHandler: function (e) {
                var $field = $(e.target);

                this.getClassTarget($field)
                    .removeClass(this.options.errorClass + ' ' + this.options.successClass);

                this.checkSuccess();
            },

            setState: function (result) {
                this.getClassTarget(result.$fields)
                    .toggleClass(this.options.errorClass, result.state !== null && !result.state)
                    .toggleClass(this.options.successClass, result.state !== null && this.options.successClass && !!result.state);
            },

            setFormState: function (state) {
                if (this.options.errorFormClass) {
                    this.$form.toggleClass(this.options.errorFormClass, !state);
                }
            },

            getClassTarget: function ($input) {
                return (this.options.addClassToParent ? $input.closest(this.options.addClassToParent) : $input);
            },

            getFormFields: function () {
                return this.$form.find(this.fieldsSelector);
            }
        };

        return publicClass;
    }());

    $.fn.formValidation = function (options) {
        options = $.extend({}, {
            errorClass: 'input-error',
            successClass: '',
            errorFormClass: '',
            addClassToParent: '',
            skipDefaultFields: ':button, :submit, :image, :hidden, :reset',
            skipFields: '',
            successSendClass: ''
        }, options);

        return this.each(function () {
            new FormValidation(this, options).init();
        });
    };
}(jQuery));

/*
 * Simple Mobile Navigation
 */
; (function ($) {
    function MobileNav(options) {
        this.options = $.extend({
            container: null,
            hideOnClickOutside: false,
            menuActiveClass: 'nav-active',
            menuOpener: '.nav-opener',
            menuDrop: '.nav-drop',
            toggleEvent: 'click',
            outsideClickEvent: 'click touchstart pointerdown MSPointerDown',
            actionOnOpen: 'toggle'
        }, options);
        this.initStructure();
        this.attachEvents();
    }
    MobileNav.prototype = {
        initStructure: function () {
            this.page = $('html');
            this.container = $(this.options.container);
            this.opener = this.container.find(this.options.menuOpener);
            this.drop = this.container.find(this.options.menuDrop);
        },
        attachEvents: function () {
            var self = this;

            if (activateResizeHandler) {
                activateResizeHandler();
                activateResizeHandler = null;
            }

            this.outsideClickHandler = function (e) {
                if (self.isOpened()) {
                    var target = $(e.target);
                    if (!target.closest(self.opener).length && !target.closest(self.drop).length && !target.closest('.jcf-select-drop').length) {
                        self.hide();
                    }
                }
            };

            this.openerClickHandler = function (e) {
                e.preventDefault();
                if (self.options.actionOnOpen == 'toggle') {
                    self.toggle();
                } else {
                    self.show();
                }
            };

            this.opener.on(this.options.toggleEvent, this.openerClickHandler);
        },
        isOpened: function () {
            return this.container.hasClass(this.options.menuActiveClass);
        },
        show: function () {
            this.container.addClass(this.options.menuActiveClass);
            if (this.options.hideOnClickOutside) {
                this.page.on(this.options.outsideClickEvent, this.outsideClickHandler);
            }
        },
        hide: function () {
            this.container.removeClass(this.options.menuActiveClass);
            if (this.options.hideOnClickOutside) {
                this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
            }
        },
        toggle: function () {
            if (this.isOpened()) {
                this.hide();
            } else {
                this.show();
            }
        },
        destroy: function () {
            this.container.removeClass(this.options.menuActiveClass);
            this.opener.off(this.options.toggleEvent, this.clickHandler);
            this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
        }
    };

    var activateResizeHandler = function () {
        var win = $(window),
            doc = $('html'),
            resizeClass = 'resize-active',
            flag, timer;
        var removeClassHandler = function () {
            flag = false;
            doc.removeClass(resizeClass);
        };
        var resizeHandler = function () {
            if (!flag) {
                flag = true;
                doc.addClass(resizeClass);
            }
            clearTimeout(timer);
            timer = setTimeout(removeClassHandler, 500);
        };
        win.on('resize orientationchange', resizeHandler);
    };

    $.fn.mobileNav = function (opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        return this.each(function () {
            var $container = jQuery(this);
            var instance = $container.data('MobileNav');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                $container.data('MobileNav', new MobileNav($.extend({
                    container: this
                }, opt)));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    };
}(jQuery));

// /*
//  * Responsive Layout helper
//  */
var ResponsiveHelper = (function ($) {
    // init variables
    var handlers = [],
        prevWinWidth,
        win = $(window),
        nativeMatchMedia = false;

    // detect match media support
    if (window.matchMedia) {
        if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
            nativeMatchMedia = true;
        } else if (window.matchMedia.toString().indexOf('native') > -1) {
            nativeMatchMedia = true;
        }
    }

    // prepare resize handler
    function resizeHandler() {
        var winWidth = win.width();
        if (winWidth !== prevWinWidth) {
            prevWinWidth = winWidth;

            // loop through range groups
            $.each(handlers, function (index, rangeObject) {
                // disable current active area if needed
                $.each(rangeObject.data, function (property, item) {
                    if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
                        item.currentActive = false;
                        if (typeof item.disableCallback === 'function') {
                            item.disableCallback();
                        }
                    }
                });

                // enable areas that match current width
                $.each(rangeObject.data, function (property, item) {
                    if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
                        // make callback
                        item.currentActive = true;
                        if (typeof item.enableCallback === 'function') {
                            item.enableCallback();
                        }
                    }
                });
            });
        }
    }
    win.bind('load resize orientationchange', resizeHandler);

    // test range
    function matchRange(r1, r2) {
        var mediaQueryString = '';
        if (r1 > 0) {
            mediaQueryString += '(min-width: ' + r1 + 'px)';
        }
        if (r2 < Infinity) {
            mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
        }
        return matchQuery(mediaQueryString, r1, r2);
    }

    // media query function
    function matchQuery(query, r1, r2) {
        if (window.matchMedia && nativeMatchMedia) {
            return matchMedia(query).matches;
        } else if (window.styleMedia) {
            return styleMedia.matchMedium(query);
        } else if (window.media) {
            return media.matchMedium(query);
        } else {
            return prevWinWidth >= r1 && prevWinWidth <= r2;
        }
    }

    // range parser
    function parseRange(rangeStr) {
        var rangeData = rangeStr.split('..');
        var x1 = parseInt(rangeData[0], 10) || -Infinity;
        var x2 = parseInt(rangeData[1], 10) || Infinity;
        return [x1, x2].sort(function (a, b) {
            return a - b;
        });
    }

    // export public functions
    return {
        addRange: function (ranges) {
            // parse data and add items to collection
            var result = { data: {} };
            $.each(ranges, function (property, data) {
                result.data[property] = {
                    range: parseRange(property),
                    enableCallback: data.on,
                    disableCallback: data.off
                };
            });
            handlers.push(result);

            // call resizeHandler to recalculate all events
            prevWinWidth = null;
            resizeHandler();
        }
    };
}(jQuery));

/*
 * Popups plugin
 */
; (function ($) {
    function ContentPopup(opt) {
        this.options = $.extend({
            holder: null,
            popup: '.popup',
            btnOpen: '.open',
            btnClose: '.close',
            openClass: 'popup-active',
            clickEvent: 'click',
            mode: 'click',
            hideOnClickLink: true,
            hideOnClickOutside: true,
            delay: 50
        }, opt);
        if (this.options.holder) {
            this.holder = $(this.options.holder);
            this.init();
        }
    }
    ContentPopup.prototype = {
        init: function () {
            this.findElements();
            this.attachEvents();
        },
        findElements: function () {
            this.popup = this.holder.find(this.options.popup);
            this.btnOpen = this.holder.find(this.options.btnOpen);
            this.btnClose = this.holder.find(this.options.btnClose);
        },
        attachEvents: function () {
            // handle popup openers
            var self = this;
            this.clickMode = isTouchDevice || (self.options.mode === self.options.clickEvent);

            if (this.clickMode) {
                // handle click mode
                this.btnOpen.bind(self.options.clickEvent + '.popup', function (e) {
                    if (self.holder.hasClass(self.options.openClass)) {
                        if (self.options.hideOnClickLink) {
                            self.hidePopup();
                        }
                    } else {
                        self.showPopup();
                    }
                    e.preventDefault();
                });

                // prepare outside click handler
                this.outsideClickHandler = this.bind(this.outsideClickHandler, this);
            } else {
                // handle hover mode
                var timer, delayedFunc = function (func) {
                    clearTimeout(timer);
                    timer = setTimeout(function () {
                        func.call(self);
                    }, self.options.delay);
                };
                this.btnOpen.on('mouseover.popup', function () {
                    delayedFunc(self.showPopup);
                }).on('mouseout.popup', function () {
                    delayedFunc(self.hidePopup);
                });
                this.popup.on('mouseover.popup', function () {
                    delayedFunc(self.showPopup);
                }).on('mouseout.popup', function () {
                    delayedFunc(self.hidePopup);
                });
            }

            // handle close buttons
            this.btnClose.on(self.options.clickEvent + '.popup', function (e) {
                self.hidePopup();
                e.preventDefault();
            });
        },
        outsideClickHandler: function (e) {
            // hide popup if clicked outside
            var targetNode = $((e.changedTouches ? e.changedTouches[0] : e).target);
            if (!targetNode.closest(this.popup).length && !targetNode.closest(this.btnOpen).length) {
                this.hidePopup();
            }
        },
        showPopup: function () {
            // reveal popup
            this.holder.addClass(this.options.openClass);
            this.popup.css({
                display: 'block'
            });

            // outside click handler
            if (this.clickMode && this.options.hideOnClickOutside && !this.outsideHandlerActive) {
                this.outsideHandlerActive = true;
                $(document).on('click touchstart', this.outsideClickHandler);
            }
        },
        hidePopup: function () {
            // hide popup
            this.holder.removeClass(this.options.openClass);
            this.popup.css({
                display: 'none'
            });

            // outside click handler
            if (this.clickMode && this.options.hideOnClickOutside && this.outsideHandlerActive) {
                this.outsideHandlerActive = false;
                $(document).off('click touchstart', this.outsideClickHandler);
            }
        },
        bind: function (f, scope, forceArgs) {
            return function () {
                return f.apply(scope, forceArgs ? [forceArgs] : arguments);
            };
        },
        destroy: function () {
            this.popup.removeAttr('style');
            this.holder.removeClass(this.options.openClass);
            this.btnOpen.add(this.btnClose).add(this.popup).off('.popup');
            $(document).off('click touchstart', this.outsideClickHandler);
        }
    };

    // detect touch devices
    var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;

    // jQuery plugin interface
    $.fn.contentPopup = function (opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        return this.each(function () {
            var $holder = jQuery(this);
            var instance = $holder.data('ContentPopup');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                $holder.data('ContentPopup', new ContentPopup($.extend({
                    holder: this
                }, opt)));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    };
}(jQuery));

/*
 * jQuery SlideMenu plugin
 */
; (function ($) {
    function SlideMenu(options) {
        this.options = $.extend({
            holder: 'null',
            item: '.has-drop-down',
            opener: '.has-drop-down-a',
            slide: '.dropdown',
            btnBack: '.link-back',
            gapNum: 0,
            difNum: 0,
            animSpeed: 500
        }, options);

        this.init();
    }
    SlideMenu.prototype = {
        init: function () {
            this.findElements();
            this.makeCallback('onInit', this);
            this.attachEvents();
        },
        findElements: function () {
            this.holder = jQuery(this.options.holder);
            this.menuWrapper = jQuery(this.options.menuWrapper);
            this.items = this.holder.find(this.options.item);
            this.openers = this.holder.find(this.options.opener);
            this.slides = this.holder.find(this.options.slide);
            this.btnBack = this.holder.find(this.options.btnBack);

            this.curStep = 0;
        },
        attachEvents: function () {
            var self = this;
            var $win = jQuery(window);

            this.showHandler = function (e) {
                e.preventDefault();
                self.activeIndex = self.openers.index(e.currentTarget);
                self.showSlide();
            };

            this.backHandler = function (e) {
                e.preventDefault();
                self.activeIndex = self.btnBack.index(e.currentTarget);
                self.hideSlide();
            };

            this.openers.on('click touchstart', this.showHandler);
            this.btnBack.on('click touchstart', this.backHandler);
        },
        showSlide: function () {
            var self = this;
            var curSlide = this.slides.eq(this.activeIndex);
            var prevSlide = curSlide.closest('ul');

            this.menuWrapper.css({
                'height': curSlide[0].clientHeight
            });

            var ratio = 0;
            var difference = 0;

            if (this.curStep !== 0) {
                difference = this.curStep * this.options.difNum + this.options.gapNum;
            } else {
                this.holder.find('.nav-drop').addClass('nav-drop-opened');
                difference = this.options.gapNum;
            }

            prevSlide.closest('.nav-drop').addClass('prev');

            curSlide.css({
                right: -(this.holder.outerWidth() + 50),
            }).addClass('current');

            curSlide.stop().animate({
                right: 0
            }, {
                    duration: self.options.animSpeed,
                    complete: function () {
                        self.curStep++;
                    }
                });
        },
        hideSlide: function () {
            var self = this;
            var curSlide = this.slides.eq(this.activeIndex);
            var prevSlide = curSlide.closest('ul');

            prevSlide.closest('.nav-drop').removeClass('prev');

            curSlide.stop().animate({
                right: -(this.holder.outerWidth() + 50),
            }, {
                    duration: self.options.animSpeed,
                    complete: function () {
                        self.curStep--;
                        curSlide.removeClass('current');
                        if (!self.holder.find(self.options.slide).filter('.current').length) {
                            self.holder.find('.nav-drop').removeClass('nav-drop-opened');
                            self.menuWrapper.css({
                                'height': ''
                            });
                        } else {
                            self.menuWrapper.css({
                                'height': curSlide.parents('.current')[0].clientHeight
                            });
                        }
                    }
                });
        },
        destroy: function () {
            this.openers.off('click touchstart', this.showHandler);
            this.btnBack.off('click touchstart', this.backHandler);
            this.slides.removeAttr('style');
            this.menuWrapper.css({ 'height': '' });
        },
        makeCallback: function (name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        }
    };

    $.fn.slideMenu = function (options) {
        return this.each(function () {
            $(this).data('SlideMenu', new SlideMenu($.extend(options, { holder: this })));
        });
    };
})(jQuery);

/*!
 * JavaScript Custom Forms : File Module
 *
 * Copyright 2014-2015 PSD2HTML - http://psd2html.com/jcf
 * Released under the MIT license (LICENSE.txt)
 *
 * Version: 1.1.3
 */
; (function ($) {

    'use strict';

    jcf.addModule({
        name: 'File',
        selector: 'input[type="file"]:not(".inputfile")',
        options: {
            fakeStructure: '<span class="jcf-file"><span class="jcf-fake-input"></span><span class="jcf-upload-button"><span class="jcf-button-content"></span></span></span>',
            buttonText: 'Choose file',
            placeholderText: 'No file chosen',
            realElementClass: 'jcf-real-element',
            extensionPrefixClass: 'jcf-extension-',
            selectedFileBlock: '.jcf-fake-input',
            buttonTextBlock: '.jcf-button-content'
        },
        matchElement: function (element) {
            return element.is('input[type="file"]');
        },
        init: function () {
            this.initStructure();
            this.attachEvents();
            this.refresh();
        },
        initStructure: function () {
            this.doc = $(document);
            this.realElement = $(this.options.element).addClass(this.options.realElementClass);
            this.fakeElement = $(this.options.fakeStructure).insertBefore(this.realElement);
            this.fileNameBlock = this.fakeElement.find(this.options.selectedFileBlock);
            this.buttonTextBlock = this.fakeElement.find(this.options.buttonTextBlock).text(this.options.buttonText);

            this.realElement.appendTo(this.fakeElement).css({
                position: 'absolute',
                opacity: 0
            });
        },
        attachEvents: function () {
            this.realElement.on({
                'jcf-pointerdown': this.onPress,
                change: this.onChange,
                focus: this.onFocus
            });
        },
        onChange: function () {
            this.refresh();
        },
        onFocus: function () {
            this.fakeElement.addClass(this.options.focusClass);
            this.realElement.on('blur', this.onBlur);
        },
        onBlur: function () {
            this.fakeElement.removeClass(this.options.focusClass);
            this.realElement.off('blur', this.onBlur);
        },
        onPress: function () {
            this.fakeElement.addClass(this.options.pressedClass);
            this.doc.on('jcf-pointerup', this.onRelease);
        },
        onRelease: function () {
            this.fakeElement.removeClass(this.options.pressedClass);
            this.doc.off('jcf-pointerup', this.onRelease);
        },
        getFileName: function () {
            var resultFileName = '',
                files = this.realElement.prop('files');

            if (files && files.length) {
                $.each(files, function (index, file) {
                    resultFileName += (index > 0 ? ', ' : '') + file.name;
                });
            } else {
                resultFileName = this.realElement.val().replace(/^[\s\S]*(?:\\|\/)([\s\S^\\\/]*)$/g, '$1');
            }

            return resultFileName;
        },
        getFileExtension: function () {
            var fileName = this.realElement.val();
            return fileName.lastIndexOf('.') < 0 ? '' : fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
        },
        updateExtensionClass: function () {
            var currentExtension = this.getFileExtension(),
                currentClassList = this.fakeElement.prop('className'),
                cleanedClassList = currentClassList.replace(new RegExp('(\\s|^)' + this.options.extensionPrefixClass + '[^ ]+', 'gi'), '');

            this.fakeElement.prop('className', cleanedClassList);
            if (currentExtension) {
                this.fakeElement.addClass(this.options.extensionPrefixClass + currentExtension);
            }
        },
        refresh: function () {
            var selectedFileName = this.getFileName() || this.options.placeholderText;
            this.fakeElement.toggleClass(this.options.disabledClass, this.realElement.is(':disabled'));
            this.fileNameBlock.text(selectedFileName);
            this.updateExtensionClass();
        },
        destroy: function () {
            // reset styles and restore element position
            this.realElement.insertBefore(this.fakeElement).removeClass(this.options.realElementClass).css({
                position: '',
                opacity: ''
            });
            this.fakeElement.remove();

            // remove event handlers
            this.realElement.off({
                'jcf-pointerdown': this.onPress,
                change: this.onChange,
                focus: this.onFocus,
                blur: this.onBlur
            });
            this.doc.off('jcf-pointerup', this.onRelease);
        }
    });

}(jQuery));

/*!
 * JavaScript Custom Forms : Number Module
 *
 * Copyright 2014-2015 PSD2HTML - http://psd2html.com/jcf
 * Released under the MIT license (LICENSE.txt)
 *
 * Version: 1.1.3
 */
; (function ($) {
    'use strict';

    jcf.addModule({
        name: 'Number',
        selector: 'input[type="number"].input-number',
        options: {
            realElementClass: 'jcf-real-element',
            fakeStructure: '<span class="jcf-number"><span class="jcf-btn-inc"></span><span class="jcf-btn-dec"></span></span>',
            btnIncSelector: '.jcf-btn-inc',
            btnDecSelector: '.jcf-btn-dec',
            pressInterval: 150
        },
        matchElement: function (element) {
            return element.is(this.selector);
        },
        init: function () {
            this.initStructure();
            this.attachEvents();
            this.refresh();
        },
        initStructure: function () {
            this.page = $('html');
            this.realElement = $(this.options.element).addClass(this.options.realElementClass);
            this.fakeElement = $(this.options.fakeStructure).insertBefore(this.realElement).prepend(this.realElement);
            this.btnDec = this.fakeElement.find(this.options.btnDecSelector);
            this.btnInc = this.fakeElement.find(this.options.btnIncSelector);

            // set initial values
            this.initialValue = parseFloat(this.realElement.val()) || 0;
            this.minValue = parseFloat(this.realElement.attr('min'));
            this.maxValue = parseFloat(this.realElement.attr('max'));
            this.stepValue = parseFloat(this.realElement.attr('step')) || 1;

            // check attribute values
            this.minValue = isNaN(this.minValue) ? -Infinity : this.minValue;
            this.maxValue = isNaN(this.maxValue) ? Infinity : this.maxValue;

            // handle range
            if (isFinite(this.maxValue)) {
                this.maxValue -= (this.maxValue - this.minValue) % this.stepValue;
            }
        },
        attachEvents: function () {
            this.realElement.on({
                focus: this.onFocus
            });
            this.btnDec.add(this.btnInc).on('jcf-pointerdown', this.onBtnPress);
        },
        onBtnPress: function (e) {
            var self = this,
                increment;

            if (!this.realElement.is(':disabled')) {
                increment = this.btnInc.is(e.currentTarget);

                self.step(increment);
                clearInterval(this.stepTimer);
                this.stepTimer = setInterval(function () {
                    self.step(increment);
                }, this.options.pressInterval);

                this.page.on('jcf-pointerup', this.onBtnRelease);
            }
        },
        onBtnRelease: function () {
            clearInterval(this.stepTimer);
            this.page.off('jcf-pointerup', this.onBtnRelease);
        },
        onFocus: function () {
            this.fakeElement.addClass(this.options.focusClass);
            this.realElement.on({
                blur: this.onBlur,
                keydown: this.onKeyPress
            });
        },
        onBlur: function () {
            this.fakeElement.removeClass(this.options.focusClass);
            this.realElement.off({
                blur: this.onBlur,
                keydown: this.onKeyPress
            });
        },
        onKeyPress: function (e) {
            if (e.which === 38 || e.which === 40) {
                e.preventDefault();
                this.step(e.which === 38);
            }
        },
        step: function (increment) {
            var originalValue = parseFloat(this.realElement.val()),
                newValue = originalValue || 0,
                addValue = this.stepValue * (increment ? 1 : -1),
                edgeNumber = isFinite(this.minValue) ? this.minValue : this.initialValue - Math.abs(newValue * this.stepValue),
                diff = Math.abs(edgeNumber - newValue) % this.stepValue;

            // handle step diff
            if (diff) {
                if (increment) {
                    newValue += addValue - diff;
                } else {
                    newValue -= diff;
                }
            } else {
                newValue += addValue;
            }

            // handle min/max limits
            if (newValue < this.minValue) {
                newValue = this.minValue;
            } else if (newValue > this.maxValue) {
                newValue = this.maxValue;
            }

            // update value in real input if its changed
            if (newValue !== originalValue) {
                this.realElement.val(newValue).trigger('change');
                this.refresh();
            }
        },
        refresh: function () {
            var isDisabled = this.realElement.is(':disabled'),
                currentValue = parseFloat(this.realElement.val());

            // handle disabled state
            this.fakeElement.toggleClass(this.options.disabledClass, isDisabled);

            // refresh button classes
            this.btnDec.toggleClass(this.options.disabledClass, currentValue === this.minValue);
            this.btnInc.toggleClass(this.options.disabledClass, currentValue === this.maxValue);
        },
        destroy: function () {
            // restore original structure
            this.realElement.removeClass(this.options.realElementClass).insertBefore(this.fakeElement);
            this.fakeElement.remove();
            clearInterval(this.stepTimer);

            // remove event handlers
            this.page.off('jcf-pointerup', this.onBtnRelease);
            this.realElement.off({
                keydown: this.onKeyPress,
                focus: this.onFocus,
                blur: this.onBlur
            });
        }
    });

}(jQuery));

/*
 * jQuery retina cover plugin
 */
; (function ($) {
    'use strict';

    var styleRules = {};
    var templates = {
        '2x': [
            '(-webkit-min-device-pixel-ratio: 1.5)',
            '(min-resolution: 192dpi)',
            '(min-device-pixel-ratio: 1.5)',
            '(min-resolution: 1.5dppx)'
        ],
        '3x': [
            '(-webkit-min-device-pixel-ratio: 3)',
            '(min-resolution: 384dpi)',
            '(min-device-pixel-ratio: 3)',
            '(min-resolution: 3dppx)'
        ]
    };

    function addSimple(imageSrc, media, id) {
        var style = buildRule(id, imageSrc);

        addRule(media, style);
    }

    function addRetina(imageData, media, id) {
        var currentRules = templates[imageData[1]].slice();
        var patchedRules = currentRules;
        var style = buildRule(id, imageData[0]);

        if (media !== 'default') {
            patchedRules = $.map(currentRules, function (ele, i) {
                return ele + ' and ' + media;
            });
        }

        media = patchedRules.join(',');

        addRule(media, style);
    }

    function buildRule(id, src) {
        return '#' + id + '{background-image: url("' + src + '");}';
    }

    function addRule(media, rule) {
        var $styleTag = styleRules[media];
        var styleTagData;
        var rules = '';

        if (media === 'default') {
            rules = rule + ' ';
        } else {
            rules = '@media ' + media + '{' + rule + '}';
        }

        if (!$styleTag) {
            styleRules[media] = $('<style>').text(rules).appendTo('head');
        } else {
            styleTagData = $styleTag.text();
            styleTagData = styleTagData.substring(0, styleTagData.length - 2) + ' }' + rule + '}';
            $styleTag.text(styleTagData);
        }
    }

    $.fn.retinaCover = function () {
        return this.each(function () {
            var $block = $(this);
            var $items = $block.children('[data-srcset]');
            var id = 'bg-stretch' + Date.now() + (Math.random() * 1000).toFixed(0);

            if ($items.length) {
                $block.attr('id', id);

                $items.each(function () {
                    var $item = $(this);
                    var data = $item.data('srcset').split(', ');
                    var media = $item.data('media') || 'default';
                    var dataLength = data.length;
                    var itemData;
                    var i;

                    for (i = 0; i < dataLength; i++) {
                        itemData = data[i].split(' ');

                        if (itemData.length === 1) {
                            addSimple(itemData[0], media, id);
                        } else {
                            addRetina(itemData, media, id);
                        }
                    }
                });
            }

            $items.detach();
        });
    };
}(jQuery));

/*
 * jQuery Load More plugin
 */
; (function ($, $win) {
    'use strict';

    var ScrollLoader = {
        attachEvents: function () {
            var self = this;

            $win.on('load.ScrollLoader resize.ScrollLoader orientationchange.ScrollLoader', function () { self.onResizeHandler(); });
            $win.on('scroll.ScrollLoader', function () { self.onScrollHandler(); });
            this.$holder.on('ContentLoader/loaded.ScrollLoader', function () { self.onResizeHandler(); });

            this.winProps = {};
            this.holderProps = {};
            this.onResizeHandler();
        },

        onResizeHandler: function () {
            this.winProps.height = $win.height();
            this.holderProps.height = this.$holder.outerHeight();
            this.holderProps.offset = this.$holder.offset().top;

            this.onScrollHandler();
        },

        onScrollHandler: function () {
            this.winProps.scroll = $win.scrollTop();

            if (this.winProps.scroll + this.winProps.height + Math.min(1, this.options.additionBottomOffset) > this.holderProps.height + this.holderProps.offset) {
                this.loadInclude();
            }
        },

        destroySubEvents: function () {
            $win.off('.ScrollLoader');
            this.$holder.off('.ScrollLoader');
        }
    };

    var ClickLoader = {
        attachEvents: function () {
            var self = this;

            this.$holder.on('click.ClickLoader', this.options.linkSelector, function (e) { self.onClickHandler(e); });
        },

        onClickHandler: function (e) {
            e.preventDefault();
            var topOffset = jQuery(window).scrollTop();

            this.$holder.trigger('ContentLoader/loading');

            this.loadInclude();
        },

        destroySubEvents: function () {
            this.$holder.off('.ClickLoader');
        }
    };

    var ContentLoader = function ($holder, options) {
        this.$holder = $holder;
        this.options = options;

        this.init();
    };

    var ContentLoaderProto = {
        init: function () {
            this.$link = this.$holder.find(this.options.linkSelector);
            this.$newContentTarget = this.options.newContentTarget ? this.$holder.find(this.options.newContentTarget) : this.$holder;

            if (!this.$link.length) {
                this.removeInstance();
                return;
            }

            this.attachEvents();
        },

        loadInclude: function () {
            if (this.isBusy) {
                return;
            }

            var self = this;

            this.toggleBusyMode(true);

            $.get(self.$link.attr('href'), function (source) { self.successHandler(source); });
        },

        successHandler: function (include) {
            var $tmpDiv = jQuery('<div>').html(include);
            var $nextIncludeLink = $tmpDiv.find(this.options.linkSelector);

            if ($nextIncludeLink.length) {
                this.refreshLink($nextIncludeLink);
            } else {
                this.destroy();
            }

            this.appendItems($tmpDiv.children());
        },

        appendItems: function ($newItems) {
            var self = this;

            this.$newContentTarget.append($newItems.addClass(this.options.preAppendClass));

            setTimeout(function () { // need this timeout coz need some time for css preAppendClass applied to the new items
                $newItems.removeClass(self.options.preAppendClass);

                self.toggleBusyMode(false);
                self.$holder.trigger('ContentLoader/loaded');
            }, 100);

            if (window.picturefill) {
                window.picturefill();
            }
        },

        refreshLink: function ($nextIncludeLink) {
            this.$link.attr('href', $nextIncludeLink.attr('href'));
            $nextIncludeLink.remove();
        },

        toggleBusyMode: function (state) {
            this.$holder.toggleClass(this.options.busyClass, state);
            this.isBusy = state;
        },

        removeInstance: function () {
            this.$holder.removeData('ContentLoader');
        },

        destroy: function () {
            this.removeInstance();
            this.destroySubEvents();

            this.$link.remove();
        }
    };

    $.fn.loadMore = function (opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        var options = $.extend({
            scroll: false,
            linkSelector: '.load-more',
            newContentTarget: null,
            busyClass: 'is-busy',
            additionBottomOffset: 50,
            preAppendClass: 'new-item'
        }, opt);

        return this.each(function () {
            var $holder = jQuery(this);
            var instance = $holder.data('ContentLoader');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                ContentLoader.prototype = $.extend(options.scroll ? ScrollLoader : ClickLoader, ContentLoaderProto);

                $holder.data('ContentLoader', new ContentLoader($holder, options));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    };
}(jQuery, jQuery(window)));

/*
 * jQuery Accordion plugin new
 */
; (function (root, factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        root.SlideAccordion = factory(jQuery);
    }
}(this, function ($) {
    'use strict';
    var accHiddenClass = 'js-acc-hidden';

    function SlideAccordion(options) {
        this.options = $.extend(true, {
            allowClickWhenExpanded: false,
            activeClass: 'active',
            opener: '.opener',
            slider: '.slide',
            animSpeed: 300,
            collapsible: true,
            event: 'click',
            scrollToActiveItem: {
                enable: false,
                breakpoint: 767, // max-width
                animSpeed: 600,
                extraOffset: null
            }
        }, options);
        this.init();
    }

    SlideAccordion.prototype = {
        init: function () {
            if (this.options.holder) {
                this.findElements();
                this.setStateOnInit();
                this.attachEvents();
                this.makeCallback('onInit');
            }
        },

        findElements: function () {
            this.$holder = $(this.options.holder).data('SlideAccordion', this);
            this.$items = this.$holder.find(':has(' + this.options.slider + ')');
        },

        setStateOnInit: function () {
            var self = this;

            this.$items.each(function () {
                if (!$(this).hasClass(self.options.activeClass)) {
                    $(this).find(self.options.slider).addClass(accHiddenClass);
                }
            });
        },

        attachEvents: function () {
            var self = this;

            this.accordionToggle = function (e) {
                var $item = jQuery(this).closest(self.$items);
                var $actiItem = self.getActiveItem($item);

                if (!self.options.allowClickWhenExpanded || !$item.hasClass(self.options.activeClass)) {
                    e.preventDefault();
                    self.toggle($item, $actiItem);
                }
            };

            this.$items.on(this.options.event, this.options.opener, this.accordionToggle);
        },

        toggle: function ($item, $prevItem) {
            if (!$item.hasClass(this.options.activeClass)) {
                this.show($item);
            } else if (this.options.collapsible) {
                this.hide($item);
            }

            if (!$item.is($prevItem) && $prevItem.length) {
                this.hide($prevItem);
            }

            this.makeCallback('beforeToggle');
        },

        show: function ($item) {
            var $slider = $item.find(this.options.slider);

            $item.addClass(this.options.activeClass);
            $slider.stop().hide().removeClass(accHiddenClass).slideDown({
                duration: this.options.animSpeed,
                complete: function () {
                    $slider.removeAttr('style');
                    if (
                        this.options.scrollToActiveItem.enable &&
                        window.innerWidth <= this.options.scrollToActiveItem.breakpoint
                    ) {
                        this.goToItem($item);
                    }
                    this.makeCallback('onShow', $item);
                }.bind(this)
            });

            this.makeCallback('beforeShow', $item);
        },

        hide: function ($item) {
            var $slider = $item.find(this.options.slider);

            $item.removeClass(this.options.activeClass);
            $slider.stop().show().slideUp({
                duration: this.options.animSpeed,
                complete: function () {
                    $slider.addClass(accHiddenClass);
                    $slider.removeAttr('style');
                    this.makeCallback('onHide', $item);
                }.bind(this)
            });

            this.makeCallback('beforeHide', $item);
        },

        goToItem: function ($item) {
            var itemOffset = $item.offset().top;

            if (itemOffset < $(window).scrollTop()) {
                // handle extra offset
                if (typeof this.options.scrollToActiveItem.extraOffset === 'number') {
                    itemOffset -= this.options.scrollToActiveItem.extraOffset;
                } else if (typeof this.options.scrollToActiveItem.extraOffset === 'function') {
                    itemOffset -= this.options.scrollToActiveItem.extraOffset();
                }

                $('body, html').animate({
                    scrollTop: itemOffset
                }, this.options.scrollToActiveItem.animSpeed);
            }
        },

        getActiveItem: function ($item) {
            return $item.siblings().filter('.' + this.options.activeClass);
        },

        makeCallback: function (name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        },

        destroy: function () {
            this.$holder.removeData('SlideAccordion');
            this.$items.off(this.options.event, this.options.opener, this.accordionToggle);
            this.$items.removeClass(this.options.activeClass).each(function (i, item) {
                $(item).find(this.options.slider).removeAttr('style').removeClass(accHiddenClass);
            }.bind(this));
            this.makeCallback('onDestroy');
        }
    };

    $.fn.slideAccordion = function (opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        return this.each(function () {
            var $holder = jQuery(this);
            var instance = $holder.data('SlideAccordion');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                new SlideAccordion($.extend(true, {
                    holder: this
                }, opt));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    };

    (function () {
        var tabStyleSheet = $('<style type="text/css">')[0];
        var tabStyleRule = '.' + accHiddenClass;
        tabStyleRule += '{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important; width: 100% !important;}';
        if (tabStyleSheet.styleSheet) {
            tabStyleSheet.styleSheet.cssText = tabStyleRule;
        } else {
            tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
        }
        $('head').append(tabStyleSheet);
    }());

    return SlideAccordion;
}));


/*!
 * SmoothScroll module
 */
; (function (root, factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        root.SmoothScroll = factory(jQuery);
    }
}(function ($) {
    // private variables
    var page,
        win = $(window),
        activeBlock, activeWheelHandler,
        wheelEvents = ('onwheel' in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel DOMMouseScroll');

    // animation handlers
    function scrollTo(offset, options, callback) {
        // initialize variables
        var scrollBlock;
        if (document.body) {
            if (typeof options === 'number') {
                options = {
                    duration: options
                };
            } else {
                options = options || {};
            }
            page = page || $('html, body');
            scrollBlock = options.container || page;
        } else {
            return;
        }

        // treat single number as scrollTop
        if (typeof offset === 'number') {
            offset = {
                top: offset
            };
        }

        // handle mousewheel/trackpad while animation is active
        if (activeBlock && activeWheelHandler) {
            activeBlock.off(wheelEvents, activeWheelHandler);
        }
        if (options.wheelBehavior && options.wheelBehavior !== 'none') {
            activeWheelHandler = function (e) {
                if (options.wheelBehavior === 'stop') {
                    scrollBlock.off(wheelEvents, activeWheelHandler);
                    scrollBlock.stop();
                } else if (options.wheelBehavior === 'ignore') {
                    e.preventDefault();
                }
            };
            activeBlock = scrollBlock.on(wheelEvents, activeWheelHandler);
        }

        // start scrolling animation
        scrollBlock.stop().animate({
            scrollLeft: offset.left,
            scrollTop: offset.top
        }, options.duration, function () {
            if (activeWheelHandler) {
                scrollBlock.off(wheelEvents, activeWheelHandler);
            }
            if ($.isFunction(callback)) {
                callback();
            }
        });
    }

    // smooth scroll contstructor
    function SmoothScroll(options) {
        this.options = $.extend({
            anchorLinks: 'a[href^="#"]', // selector or jQuery objectsl
            container: null, // specify container for scrolling (default - whole page)
            extraOffset: null, // function or fixed number
            activeClasses: null, // null, "link", "parent"
            easing: 'swing', // easing of scrolling
            animMode: 'duration', // or "speed" mode
            animDuration: 800, // total duration for scroll (any distance)
            animSpeed: 1500, // pixels per second
            anchorActiveClass: 'anchor-active',
            sectionActiveClass: 'section-active',
            wheelBehavior: 'stop', // "stop", "ignore" or "none"
            useNativeAnchorScrolling: false // do not handle click in devices with native smooth scrolling
        }, options);
        this.init();
    }
    SmoothScroll.prototype = {
        init: function () {
            this.initStructure();
            this.attachEvents();
            this.isInit = true;
        },
        initStructure: function () {
            var self = this;

            this.container = this.options.container ? $(this.options.container) : $('html,body');
            this.scrollContainer = this.options.container ? this.container : win;
            this.anchorLinks = jQuery(this.options.anchorLinks).filter(function () {
                return jQuery(self.getAnchorTarget(jQuery(this))).length;
            });
        },
        getId: function (str) {
            try {
                return '#' + str.replace(/^.*?(#|$)/, '');
            } catch (err) {
                return null;
            }
        },
        getAnchorTarget: function (link) {
            // get target block from link href
            var targetId = this.getId($(link).attr('href'));
            return $(targetId.length > 1 ? targetId : 'html');
        },
        getTargetOffset: function (block) {
            // get target offset
            var blockOffset = block.offset().top;
            if (this.options.container) {
                blockOffset -= this.container.offset().top - this.container.prop('scrollTop');
            }

            // handle extra offset
            if (typeof this.options.extraOffset === 'number') {
                blockOffset -= this.options.extraOffset;
            } else if (typeof this.options.extraOffset === 'function') {
                blockOffset -= this.options.extraOffset(block);
            }
            return {
                top: blockOffset
            };
        },
        attachEvents: function () {
            var self = this;

            // handle active classes
            if (this.options.activeClasses && this.anchorLinks.length) {
                // cache structure
                this.anchorData = [];

                for (var i = 0; i < this.anchorLinks.length; i++) {
                    var link = jQuery(this.anchorLinks[i]),
                        targetBlock = self.getAnchorTarget(link),
                        anchorDataItem = null;

                    $.each(self.anchorData, function (index, item) {
                        if (item.block[0] === targetBlock[0]) {
                            anchorDataItem = item;
                        }
                    });

                    if (anchorDataItem) {
                        anchorDataItem.link = anchorDataItem.link.add(link);
                    } else {
                        self.anchorData.push({
                            link: link,
                            block: targetBlock
                        });
                    }
                };

                // add additional event handlers
                this.resizeHandler = function () {
                    if (!self.isInit) return;
                    self.recalculateOffsets();
                };
                this.scrollHandler = function () {
                    self.refreshActiveClass();
                };

                this.recalculateOffsets();
                this.scrollContainer.on('scroll', this.scrollHandler);
                win.on('resize load orientationchange refreshAnchor', this.resizeHandler);
            }

            // handle click event
            this.clickHandler = function (e) {
                self.onClick(e);
            };
            if (!this.options.useNativeAnchorScrolling) {
                this.anchorLinks.on('click', this.clickHandler);
            }
        },
        recalculateOffsets: function () {
            var self = this;
            $.each(this.anchorData, function (index, data) {
                data.offset = self.getTargetOffset(data.block);
                data.height = data.block.outerHeight();
            });
            this.refreshActiveClass();
        },
        toggleActiveClass: function (anchor, block, state) {
            anchor.toggleClass(this.options.anchorActiveClass, state);
            block.toggleClass(this.options.sectionActiveClass, state);
        },
        refreshActiveClass: function () {
            var self = this,
                foundFlag = false,
                containerHeight = this.container.prop('scrollHeight'),
                viewPortHeight = this.scrollContainer.height(),
                scrollTop = this.options.container ? this.container.prop('scrollTop') : win.scrollTop();

            // user function instead of default handler
            if (this.options.customScrollHandler) {
                this.options.customScrollHandler.call(this, scrollTop, this.anchorData);
                return;
            }

            // sort anchor data by offsets
            this.anchorData.sort(function (a, b) {
                return a.offset.top - b.offset.top;
            });

            // default active class handler
            $.each(this.anchorData, function (index) {
                var reverseIndex = self.anchorData.length - index - 1,
                    data = self.anchorData[reverseIndex],
                    anchorElement = (self.options.activeClasses === 'parent' ? data.link.parent() : data.link);

                if (scrollTop >= containerHeight - viewPortHeight) {
                    // handle last section
                    if (reverseIndex === self.anchorData.length - 1) {
                        self.toggleActiveClass(anchorElement, data.block, true);
                    } else {
                        self.toggleActiveClass(anchorElement, data.block, false);
                    }
                } else {
                    // handle other sections
                    if (!foundFlag && (scrollTop >= data.offset.top - 1 || reverseIndex === 0)) {
                        foundFlag = true;
                        self.toggleActiveClass(anchorElement, data.block, true);
                    } else {
                        self.toggleActiveClass(anchorElement, data.block, false);
                    }
                }
            });
        },
        calculateScrollDuration: function (offset) {
            var distance;
            if (this.options.animMode === 'speed') {
                distance = Math.abs(this.scrollContainer.scrollTop() - offset.top);
                return (distance / this.options.animSpeed) * 1000;
            } else {
                return this.options.animDuration;
            }
        },
        onClick: function (e) {
            var targetBlock = this.getAnchorTarget(e.currentTarget),
                targetOffset = this.getTargetOffset(targetBlock);

            e.preventDefault();
            scrollTo(targetOffset, {
                container: this.container,
                wheelBehavior: this.options.wheelBehavior,
                duration: this.calculateScrollDuration(targetOffset)
            });
            this.makeCallback('onBeforeScroll', e.currentTarget);
        },
        makeCallback: function (name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        },
        destroy: function () {
            var self = this;

            this.isInit = false;
            if (this.options.activeClasses) {
                win.off('resize load orientationchange refreshAnchor', this.resizeHandler);
                this.scrollContainer.off('scroll', this.scrollHandler);
                $.each(this.anchorData, function (index) {
                    var reverseIndex = self.anchorData.length - index - 1,
                        data = self.anchorData[reverseIndex],
                        anchorElement = (self.options.activeClasses === 'parent' ? data.link.parent() : data.link);

                    self.toggleActiveClass(anchorElement, data.block, false);
                });
            }
            this.anchorLinks.off('click', this.clickHandler);
        }
    };

    // public API
    $.extend(SmoothScroll, {
        scrollTo: function (blockOrOffset, durationOrOptions, callback) {
            scrollTo(blockOrOffset, durationOrOptions, callback);
        }
    });

    // always export API to the global window object
    window.SmoothScroll = SmoothScroll;

}(jQuery)));

/*
 * jQuery touch menu plugin
 */
; (function ($) {
    function MenuDrop(options) {
        this.options = $.extend({
            activeClass: 'hover',
            dropHolder: '.opener',
            drop: '.slide',
        }, options);
        this.init();
    }
    MenuDrop.prototype = {
        init: function () {
            if (this.options.holder) {
                this.findElements();
                this.attachEvents();
                this.makeCallback('onInit', this);
            }
        },
        findElements: function () {
            this.holder = $(this.options.holder);
            this.dropHolders = this.holder.find(this.options.dropHolder);
        },
        attachEvents: function () {
            var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
            var win = jQuery(window);
            var self = this;

            this.dropHolders.each(function () {
                var dropHolder = jQuery(this);
                var drop = dropHolder.find(self.options.drop);

                this.enterHandler = function () {
                    var winLeft = win.width();
                    var dropWidth = drop.outerWidth();
                    var dropLeft = drop.offset().left + dropWidth;

                    dropHolder.addClass(self.options.activeClass);

                    if (dropLeft > winLeft - 25) {
                        // drop.css({
                        //   marginLeft: winLeft - dropLeft
                        // })
                        //console.log(drop.closest('.nav-drop'))
                        // if (drop.closest('li').length) {
                        //   drop.closest('li').addClass('flipped');
                        // }
                        drop.addClass('flipped');
                    }
                }

                this.leaveHandler = function () {
                    dropHolder.removeClass(self.options.activeClass);
                    // drop.css({
                    //   marginLeft: ''
                    // })
                    // if (drop.closest('li').length) {
                    //       drop.closest('li').removeClass('flipped');
                    //     }
                    drop.removeClass('flipped');
                }

                this.outsideClickHandler = function (e) {
                    var target = $(e.target);
                    if (!target.is(self.holder) && !target.closest(self.holder).length) {
                        self.hideSlide();
                    }
                };

                dropHolder.on('mouseover touchstart', this.enterHandler);
                dropHolder.on('mouseleave', this.leaveHandler);
            });
        },
        destroy: function () {
            this.dropHolders.removeClass(this.options.activeClass).css({
                marginLeft: ''
            });
            this.dropHolders.off('mouseover touchstart', this.enterHandler);
            this.dropHolders.off('mouseleave', this.leaveHandler);
            this.holder.removeClass(this.options.activeClass).removeData('MenuDrop');
        },
        makeCallback: function (name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        }
    };

    // jQuery plugin interface
    $.fn.menuDrop = function (opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        return this.each(function () {
            var $holder = jQuery(this);
            var instance = $holder.data('MenuDrop');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                $holder.data('MenuDrop', new MenuDrop($.extend({
                    holder: this
                }, opt)));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    };
}(jQuery));



// WEBPACK FOOTER //
// ./scripts/src/index.js